/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/




  
  (function() {

    /* GG MOD START - log di debug NobileAutoGift.
       Spegnimento: metti AUTOGIFT_DEBUG_DEFAULT a false, oppure da console
       nobileAutoGiftDebug(false) / window.NOBILE_AUTOGIFT_DEBUG = false.
       Accensione puntuale: ?autogift_debug=1 in querystring. */
    const AUTOGIFT_DEBUG_DEFAULT = false;

    function autoGiftDebugEnabled() {
      try {
        if (typeof window.NOBILE_AUTOGIFT_DEBUG === 'boolean') return window.NOBILE_AUTOGIFT_DEBUG;
        const stored = window.localStorage.getItem('nobileAutoGiftDebug');
        if (stored !== null) return stored === 'true';
        if (/[?&]autogift_debug=1/.test(window.location.search)) return true;
      } catch (e) { /* storage non accessibile: si usa il default */ }
      return AUTOGIFT_DEBUG_DEFAULT;
    }

    function agLog(label, data) {
      if (!autoGiftDebugEnabled()) return;
      if (data === undefined) console.log(`[NobileAutoGift] ${label}`);
      else console.log(`[NobileAutoGift] ${label}`, data);
    }

    window.nobileAutoGiftDebug = function(on = true) {
      window.NOBILE_AUTOGIFT_DEBUG = !!on;
      try { window.localStorage.setItem('nobileAutoGiftDebug', String(!!on)); } catch (e) {}
      console.log(`[NobileAutoGift] debug ${on ? 'ON' : 'OFF'}`);
    };
    /* GG MOD END */

    /* GG MOD START - interruttore unico degli attributi carrello di NobileAutoGift.
       A false non si scrivono _autoGift (diagnostica), _autoGiftRemovedEvents (rimozioni manuali)
       né _autoGiftBoot (watchdog, che legge window.NOBILE_AUTOGIFT_ATTRIBUTES). La diagnostica
       resta consultabile da console con nobileAutoGiftDiag(). */
    const AUTOGIFT_ATTRIBUTES_ENABLED = true;
    window.NOBILE_AUTOGIFT_ATTRIBUTES = AUTOGIFT_ATTRIBUTES_ENABLED;
    /* GG MOD END */

    class NobileCartDiscountsWatcher {

      isLoaded() {
        return (document.querySelector('.nobile-applied-cart-discounts1') ? true : false);
      }

      /* GG MOD START  - guard smart AIOD con detection + readiness e polling */
      hasAiodApp() {
        return (
          typeof window.csappsStart === 'function'
          || !!(window.csapps && window.csapps.discounts)
          || !!document.querySelector('.csapp_discount_total_wrapper')
        );
      }

      isAiodReady() {
        return !!(
          window.csapps
          && window.csapps.discounts
          && Array.isArray(window.csapps.discounts.cart_level_discount_applications)
        );
      }

      waitForAiodReady({ attempts = 1, delay = 400 } = {}) {
        if (this.isAiodReady()) return Promise.resolve(true);

        return new Promise((resolve) => {
          let remainingAttempts = Math.max(0, attempts);

          if (remainingAttempts === 0) {
            resolve(false);
            return;
          }

          const check = () => {
            if (this.isAiodReady()) {
              resolve(true);
              return;
            }

            remainingAttempts -= 1;
            if (remainingAttempts <= 0) {
              resolve(false);
              return;
            }

            setTimeout(check, delay);
          };

          setTimeout(check, delay);
        });
      }

      init() {
        const wrapper = document.querySelector('.csapp_discount_total_wrapper');
        if (!wrapper || !wrapper.parentNode) return false;

        const clonedWrapper = wrapper.cloneNode(true);
        const newContainer = document.createElement('div');

        newContainer.style.display = 'flex';
        newContainer.style.flexDirection = 'row';
        newContainer.style.alignItems = 'flex-start';

        const div1 = document.createElement('div');
        const div2 = document.createElement('div');

        div1.classList.add('nobile-applied-cart-discounts1');
        div1.style.flex = '1 0 40%';
        div1.style.padding = 'var(--gutter)';

        div2.appendChild(clonedWrapper);
        div2.style.flex = '1 0 60%';
        div2.style.display = 'flex';
        div2.style.flexDirection = 'column';
        div2.style.alignItems = 'flex-end';

        newContainer.appendChild(div1);
        newContainer.appendChild(div2);

        wrapper.parentNode.insertBefore(newContainer, wrapper.nextSibling);
        wrapper.remove();

        document.addEventListener('click', function(event) {
          if (event.target.closest('.csapp_aiod_coupan_btn')) {
            fetch('/cart.js')
              .then(response => response.json())
              .then(_cart => {
                setTimeout(() => nobileCartDiscountsWatcher.cartChanged(_cart), 3000);
              })
              .catch(error => {
                  console.error('Fetch error:', error);
              });
          }
        });

        return true;
      }
    
      /*observeDiscountCodeChange() {
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        
        const callback = function(mutationsList, observer) {
          for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && node.matches('p.csapp_coupan_success')) {
                  //fetch('/cart.js');
                  //nobileCartDiscountsWatcher.cartChanged(null);
                }
              });
            }
          }
        };
        
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }*/
    
      /*observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
            const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
            const isCartChangeRequest = /\/cart\//.test(entry.name);
            if (isValidRequestType && isCartChangeRequest) {
              setTimeout(() => this.cartChanged(), 3000);
            }
          });
        });
        cartObserver.observe({ entryTypes: ["resource"] });
      }*/

      loadDiscountsDisplay(){
        if (!this.isAiodReady()) return;

        const cartDiscountWrapper = document.querySelector('.nobile-applied-cart-discounts1');
        if (!cartDiscountWrapper) return;
        if (!window.csapps || typeof themeVendor.themeCurrency.formatMoney !== 'function') return;

        const discountApplications = window.csapps.discounts.cart_level_discount_applications;
        if (!Array.isArray(discountApplications)) return;

        cartDiscountWrapper.innerHTML = '';

        // Keep the existing code for cart level discounts
        discountApplications.forEach((discount) => {
          const discountContainer = document.createElement('div');
          discountContainer.style.display = 'flex';
          discountContainer.style.alignItems = 'flex-start';
          discountContainer.style.marginBottom = '10px';
          discountContainer.style.fontSize = '100%';
          discountContainer.style.justifyContent = 'unset';
          discountContainer.style.webkitBoxAlign = 'unset';
          discountContainer.classList.add('cscode_msg');
      
          const discountImage = document.createElement('img');
          discountImage.src = (discount.type=='automatic' && discount.title=='Paia in Regalo' ? 'https://cdn.shopify.com/s/files/1/0555/9435/2936/files/sock-icon.png?v=1769785844' : 'https://nobileitaly.com/cdn/shop/t/113/assets/discount-icon.png');
          discountImage.style.width = '22px';
          discountImage.style.height = 'auto';
          discountImage.style.marginRight = '6px';

          // Add error handler to replace with your exact SVG if image fails to load
          discountImage.onerror = function() {
            const svgIcon = document.createElement('div');
            // This is your exact SVG icon, optimized for inline use
            svgIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 230 230" style="min-width: 22px; margin-right: 6px;">
              <g transform="translate(0,230) scale(0.1,-0.1)" fill="#000000">
                <path d="M1025 2220 c-435 -56 -788 -357 -910 -777 -164 -563 170 -1163 739 -1327 444 -129 934 51 1189 436 345 520 186 1210 -351 1527 -189 112 -454 168 -667 141z m388 -144 c326 -98 563 -334 664 -663 25 -81 27 -101 27 -263 0 -162 -2 -182 -27 -263 -50 -162 -134 -305 -247 -417 -112 -113 -255 -197 -417 -247 -81 -25 -101 -27 -263 -27 -162 0 -182 2 -263 27 -329 101 -563 335 -664 664 -25 81 -27 101 -27 263 0 162 2 182 27 263 110 355 374 600 738 682 45 10 108 14 214 11 127 -3 164 -8 238 -30z"/>
                <path d="M795 1585 c-37 -16 -68 -50 -85 -93 -10 -27 -10 -41 0 -75 15 -52 39 -79 90 -102 77 -35 164 13 191 105 10 34 9 44 -12 87 -18 36 -35 53 -69 71 -50 25 -72 26 -115 7z"/>
                <path d="M1500 1588 c-30 -11 -765 -741 -786 -782 -32 -60 32 -124 92 -92 43 22 771 756 783 789 21 55 -32 106 -89 85z"/>
                <path d="M1405 988 c-46 -16 -82 -55 -95 -104 -11 -39 -10 -48 11 -91 18 -36 35 -54 70 -72 43 -23 50 -24 90 -12 57 17 105 68 114 121 9 53 -25 116 -80 147 -44 25 -64 27 -110 11z"/>
              </g>
            </svg>`;
            
            // Replace the broken image with SVG
            this.parentNode.replaceChild(svgIcon, this);
          };

            // Add error handler to replace with SVG if image fails to load
          /*
          discountImage.onerror = function() {
            const svgIcon = document.createElement('div');
            svgIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="min-width: 22px; margin-right: 6px;">
              <line x1="19" y1="5" x2="5" y2="19"></line>
              <circle cx="6.5" cy="6.5" r="2.5"></circle>
              <circle cx="17.5" cy="17.5" r="2.5"></circle>
            </svg>`;
            
            // Replace the broken image with SVG
            this.parentNode.replaceChild(svgIcon, this);
          };*/

          
    
      
          const pElement = document.createElement('p');
          pElement.style.margin = '0';
          pElement.style.fontSize = '12px';

          discount.title = (discount.title=='Paia in Regalo' && Shopify.locale=='en' ? 'Gift pairs included' : discount.title);
          discount.title = (discount.title=='Paia in Regalo' && Shopify.locale=='de' ? 'Paare als Geschenk enthalten' : discount.title);
          discount.title = (discount.title=='Paia in Regalo' && Shopify.locale=='fr' ? 'Paires offertes en cadeau' : discount.title);

          pElement.innerHTML = discount.title+'<br/>- '+themeVendor.themeCurrency.formatMoney(discount.total_allocated_amount, theme.moneyFormat);
          
          discountContainer.appendChild(discountImage);
          discountContainer.appendChild(pElement);
      
          cartDiscountWrapper.appendChild(discountContainer);
        });
        
        /* Promo S Valentino
        if (fireSValentino) {
          const discountContainer = document.createElement('div');
          discountContainer.style.display = 'flex';
          discountContainer.style.alignItems = 'flex-start';
          discountContainer.style.marginBottom = '10px';
          discountContainer.style.fontSize = '100%';
          discountContainer.style.justifyContent = 'unset';
          discountContainer.style.webkitBoxAlign = 'unset';
          discountContainer.classList.add('cscode_msg');
      
          const discountImage = document.createElement('img');
          discountImage.src = 'https://cdn.shopify.com/s/files/1/0555/9435/2936/files/featured_seasonal_and_gifts_24dp_5F021F_FILL0_wght300_GRAD0_opsz24.svg?v=1727366141';
          discountImage.style.width = '22px';
          discountImage.style.height = 'auto';
          discountImage.style.marginRight = '6px';

          const pElement = document.createElement('p');
          pElement.style.margin = '0';
          pElement.style.fontSize = '12px';
          
          pElement.innerHTML = 'Laundry bag included';
          pElement.innerHTML = (Shopify.locale=='it' ? 'Sacchetto in regalo' : pElement.innerHTML);
          pElement.innerHTML = (Shopify.locale=='fr' ? 'Filet de lavage inclus' : pElement.innerHTML);
          pElement.innerHTML = (Shopify.locale=='de' ? 'Wäschesack inklusive' : pElement.innerHTML);
          
          discountContainer.appendChild(discountImage);
          discountContainer.appendChild(pElement);
      
          cartDiscountWrapper.appendChild(discountContainer);
        }*/
      }
    
      async cartChanged(cart) {
        if (!this.hasAiodApp()) return;

        if (!this.isAiodReady()) {
          const aiodReady = await this.waitForAiodReady();
          if (!aiodReady) return;
        }

        if (!this.isLoaded()) {
          const initialized = this.init();
          if (!initialized) return;
        }

        
        /*var fireSValentino = false;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          await fetch(window.Shopify.routes.root + 'products/' + item.handle + '.js')
            .then(response => response.json())
            .then(product => {
              fireSValentino = (product.tags.includes('back_to_work_box_office') ? true : fireSValentino);
            })
            .catch(error => {
              console.error('Fetch error:', error);
            });
        }

        this.loadDiscountsDisplay(fireSValentino);*/

        this.loadDiscountsDisplay();
      }
      /* GG MOD END */
    
      /*removeDiscountCode() {
        localStorage.removeItem('aiod_codes_'+Shopify.shop);
        const elements = document.getElementsByClassName('cscode_msg');
        while(elements.length > 0){
          elements[0].parentNode.removeChild(elements[0]);
        }
      }*/
    }

    const nobileCartDiscountsWatcher = new NobileCartDiscountsWatcher;

    /* GG MOD START  - campo coupon nel cart drawer con applicazione AJAX su /cart/update.js */
    class NobileDrawerDiscountCode {
      constructor() {
        this.formSelector = '[data-cart-discount-form]';
        this.feedbackSelector = '[data-cart-discount-feedback]';
        this.codesSelector = '[data-cart-discount-codes]';
        this.removeSelector = '[data-cart-discount-remove]';
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
        this.handleCartChange = this.handleCartChange.bind(this);
      }

      init() {
        document.addEventListener('submit', this.handleSubmit);
        document.addEventListener('click', this.handleRemoveClick);
        document.addEventListener('theme:cart:change', this.handleCartChange);
      }

      cartEndpoint(suffix) {
        const cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart) ? window.theme.routes.cart : '/cart';
        return `${cartRoute}${suffix}`;
      }

      getMessages(form) {
        return {
          empty: form.dataset.emptyMessage || 'Enter a discount code.',
          invalid: form.dataset.invalidMessage || 'This discount code cannot be applied to your cart.',
          generic: form.dataset.errorMessage || 'Unable to apply the discount code. Try again.',
          success: form.dataset.successMessage || 'Discount code applied.',
          removed: form.dataset.removedMessage || 'Discount code removed.',
          removeLabel: form.dataset.removeLabel || 'Remove discount code'
        };
      }

      extractDiscountCodes(cart) {
        if (!cart) return [];

        const codes = [];

        if (Array.isArray(cart.cart_level_discount_applications)) {
          cart.cart_level_discount_applications
            .filter((application) => {
              return application && application.type === 'discount_code' && typeof application.title === 'string';
            })
            .map((application) => application.title.trim())
            .filter(Boolean)
            .forEach((code) => codes.push(code));
        }

        if (Array.isArray(cart.items)) {
          cart.items.forEach((item) => {
            if (!item || !Array.isArray(item.line_level_discount_allocations)) return;

            item.line_level_discount_allocations
              .filter((allocation) => {
                return allocation
                  && allocation.discount_application
                  && allocation.discount_application.type === 'discount_code'
                  && typeof allocation.discount_application.title === 'string';
              })
              .map((allocation) => allocation.discount_application.title.trim())
              .filter(Boolean)
              .forEach((code) => codes.push(code));
          });
        }

        if (Array.isArray(cart.discount_codes)) {
          cart.discount_codes
            .filter((application) => {
              return application && typeof application.code === 'string' && application.applicable !== false;
            })
            .map((application) => application.code.trim())
            .filter(Boolean)
            .forEach((code) => codes.push(code));
        }

        const seen = new Set();
        return codes.filter((code) => {
          const normalizedCode = code.toLowerCase();
          if (seen.has(normalizedCode)) return false;
          seen.add(normalizedCode);
          return true;
        });
      }

      mergeDiscountCodes(existingCodes, codeToAdd) {
        const normalized = new Set();
        const merged = [];

        existingCodes.concat([codeToAdd]).forEach((code) => {
          const normalizedCode = code.toLowerCase();
          if (normalized.has(normalizedCode)) return;
          normalized.add(normalizedCode);
          merged.push(code);
        });

        return merged;
      }

      getFeedbackElement(form) {
        return form.parentElement ? form.parentElement.querySelector(this.feedbackSelector) : null;
      }

      getCodesElement(form) {
        return form.parentElement ? form.parentElement.querySelector(this.codesSelector) : null;
      }

      escapeHtml(value) {
        return value
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      renderDiscountCodes(form, discountCodes) {
        const codesList = this.getCodesElement(form);
        if (!codesList) return;

        if (!Array.isArray(discountCodes) || discountCodes.length === 0) {
          codesList.innerHTML = '';
          return;
        }

        const removeLabel = this.getMessages(form).removeLabel;
        codesList.innerHTML = discountCodes.map((code) => {
          const safeCode = this.escapeHtml(code);
          const safeLabel = this.escapeHtml(removeLabel);
          return `<li class="drawer__discount-code__pill" data-discount-code="${safeCode}">
            <span class="drawer__discount-code__pill-code">${safeCode}</span>
            <button
              type="button"
              class="drawer__discount-code__pill-remove button-unstyled"
              data-cart-discount-remove="${safeCode}"
              aria-label="${safeLabel}"
            >&times;</button>
          </li>`;
        }).join('');
      }

      setControlState(form, isDisabled) {
        const input = form.querySelector('input[name="discount"]');
        const submit = form.querySelector('button[type="submit"]');
        if (input instanceof HTMLInputElement) input.disabled = isDisabled;
        if (submit instanceof HTMLButtonElement) submit.disabled = isDisabled;

        const wrapper = form.parentElement;
        if (!wrapper) return;

        wrapper.querySelectorAll(this.removeSelector).forEach((button) => {
          if (button instanceof HTMLButtonElement) {
            button.disabled = isDisabled;
          }
        });
      }

      clearFeedback(form) {
        const feedback = this.getFeedbackElement(form);
        if (!feedback) return;
        feedback.textContent = '';
        feedback.classList.remove('is-visible', 'is-error', 'is-success');
      }

      showFeedback(form, type, message) {
        const feedback = this.getFeedbackElement(form);
        if (!feedback) return;
        feedback.textContent = message;
        feedback.classList.remove('is-error', 'is-success');
        feedback.classList.add('is-visible', type === 'success' ? 'is-success' : 'is-error');
      }

      async handleSubmit(event) {
        const form = event.target.closest(this.formSelector);
        if (!form) return;

        event.preventDefault();
        event.stopPropagation();

        const input = form.querySelector('input[name="discount"]');
        if (!(input instanceof HTMLInputElement)) return;

        const messages = this.getMessages(form);
        const discountCode = input.value.trim();

        this.clearFeedback(form);

        if (!discountCode) {
          this.showFeedback(form, 'error', messages.empty);
          return;
        }

        this.setControlState(form, true);

        try {
          const cartResponse = await fetch(this.cartEndpoint('.js'));
          if (!cartResponse.ok) throw new Error('cart fetch failed');
          const currentCart = await cartResponse.json();

          const existingCodes = this.extractDiscountCodes(currentCart);
          if (existingCodes.some((code) => code.toLowerCase() === discountCode.toLowerCase())) {
            return;
          }

          agLog(`pre-submit coupon "${discountCode}" — istanze regalo: ${(window._nobileAutoGiftInstances || []).length}`);

          for (const instance of (window._nobileAutoGiftInstances || [])) {
            const rc = instance.config.requiredCoupon;
            if (!rc || rc.trim().toLowerCase() !== discountCode.toLowerCase()) continue;
            const cfg = instance.config;
            agLog(`pre-submit: coupon "${discountCode}" corrisponde alla regola (giftProductId: ${cfg.giftProductId})`);
            if (instance.findGiftItem(currentCart)) { agLog('pre-submit skip: regalo già in carrello'); continue; }

            /* GG MOD: le condizioni sono quelle della regola, valutate dal suo stesso
               metodo (coupon passato come pending, visto che sta per essere applicato).
               Riscriverle qui significherebbe tenere allineate due copie della logica. */
            const status = instance._getConditionStatus(currentCart, discountCode);
            if (!status.ok) { agLog(`pre-submit skip: ${status.reason}`, status); continue; }

            instance._pendingCouponCode = discountCode;
            try {
              agLog(`pre-submit: aggiungo regalo (giftProductId: ${cfg.giftProductId}) prima dell'apply coupon`);
              const added = await instance.addGift(currentCart, true, true);
              agLog(`pre-submit: esito aggiunta regalo — ${added ? 'aggiunto (eventi soppressi)' : 'non aggiunto'}`);
            } catch (e) {
              instance._pendingCouponCode = null;
              console.error('[NobileDrawerDiscountCode] pre-submit gift add failed:', e);
            }
          }

          const mergedCodes = this.mergeDiscountCodes(existingCodes, discountCode);

          const updateResponse = await fetch(this.cartEndpoint('/update.js'), {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              discount: mergedCodes.join(',')
            })
          });

          if (!updateResponse.ok) throw new Error('cart update failed');
          const updatedCart = await updateResponse.json();
          this.renderDiscountCodes(form, this.extractDiscountCodes(updatedCart));

          const discountStatus = Array.isArray(updatedCart.discount_codes)
            ? updatedCart.discount_codes.find((discount) => {
                return discount && typeof discount.code === 'string' && discount.code.toLowerCase() === discountCode.toLowerCase();
              })
            : null;

          if (!discountStatus || discountStatus.applicable === false) {
            agLog(`coupon "${discountCode}" non applicabile — dispatch theme:cart:change per cleanup regalo pre-aggiunto`);
            for (const instance of (window._nobileAutoGiftInstances || [])) {
              if (instance._pendingCouponCode && instance._pendingCouponCode.toLowerCase() === discountCode.toLowerCase()) {
                instance._pendingCouponCode = null;
              }
            }

            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart: updatedCart },
              bubbles: true
            }));
            this.showFeedback(form, 'error', messages.invalid);
            return;
          }

          input.value = '';
          this.showFeedback(form, 'success', messages.success);
          agLog(`coupon "${discountCode}" applicato con successo`);

          for (const instance of (window._nobileAutoGiftInstances || [])) {
            if (instance._pendingCouponCode && instance._pendingCouponCode.toLowerCase() === discountCode.toLowerCase()) {
              instance._pendingCouponCode = null;
            }
          }

          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: {
              cart: updatedCart
            },
            bubbles: true
          }));

          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
        } catch (error) {
          for (const instance of (window._nobileAutoGiftInstances || [])) {
            if (instance._pendingCouponCode && instance._pendingCouponCode.toLowerCase() === discountCode.toLowerCase()) {
              instance._pendingCouponCode = null;
            }
          }

          try {
            const cleanupResponse = await fetch(this.cartEndpoint('.js'));
            if (cleanupResponse.ok) {
              const cleanupCart = await cleanupResponse.json();
              document.dispatchEvent(new CustomEvent('theme:cart:change', {
                detail: { cart: cleanupCart },
                bubbles: true
              }));
            }
          } catch (cleanupError) {
            console.error('[NobileDrawerDiscountCode] coupon cleanup failed:', cleanupError);
          }

          this.showFeedback(form, 'error', messages.generic);
        } finally {
          this.setControlState(form, false);
        }
      }

      async handleRemoveClick(event) {
        const button = event.target.closest(this.removeSelector);
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        const discountCode = (button.getAttribute('data-cart-discount-remove') || '').trim();
        if (!discountCode) return;

        const wrapper = button.parentElement ? button.parentElement.closest('.drawer__discount-code') : null;
        if (!wrapper) return;

        const form = wrapper.querySelector(this.formSelector);
        if (!(form instanceof HTMLFormElement)) return;

        const messages = this.getMessages(form);
        this.clearFeedback(form);
        this.setControlState(form, true);

        try {
          const cartResponse = await fetch(this.cartEndpoint('.js'));
          if (!cartResponse.ok) throw new Error('cart fetch failed');
          const currentCart = await cartResponse.json();

          const existingCodes = this.extractDiscountCodes(currentCart);
          const updatedCodes = existingCodes.filter((code) => code.toLowerCase() !== discountCode.toLowerCase());

          const updateResponse = await fetch(this.cartEndpoint('/update.js'), {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              discount: updatedCodes.join(',')
            })
          });

          if (!updateResponse.ok) throw new Error('cart update failed');
          const updatedCart = await updateResponse.json();

          this.renderDiscountCodes(form, this.extractDiscountCodes(updatedCart));
          this.showFeedback(form, 'success', messages.removed);

          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: {
              cart: updatedCart
            },
            bubbles: true
          }));

          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
        } catch (error) {
          this.showFeedback(form, 'error', messages.generic);
        } finally {
          this.setControlState(form, false);
        }
      }

      handleCartChange(event) {
        const cart = event && event.detail ? event.detail.cart : null;
        if (!cart) return;

        const discountCodes = this.extractDiscountCodes(cart);
        document.querySelectorAll(this.formSelector).forEach((form) => {
          if (form instanceof HTMLFormElement) {
            this.renderDiscountCodes(form, discountCodes);
          }
        });
      }
    }

    const nobileDrawerDiscountCode = new NobileDrawerDiscountCode;
    nobileDrawerDiscountCode.init();
    /* GG MOD END */
  
    // Below are example event listeners.  They listen for theme events that Pipeline
    // fires in order to make it easier for you to add customizations.
  
    // Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.
  
    const targetElement = document.querySelector('form[action="/cart/add"]');
    const addToCartBar = document.querySelector('.nobile-sticky-add-to-cart');
    
    if (addToCartBar) {
      // Funzione che controlla la posizione dell'elemento e mostra/nasconde la barra
      function handleScroll() {
        const rect = targetElement.getBoundingClientRect();
        const targetVisible = rect.top <= 0;
    
        if (targetVisible) {
          addToCartBar.style.display = 'flex'; // Mostra la barra quando superi il form
          document.querySelector('.nobile-footer-wrapper').style.zIndex = '1001';
        } else {
          addToCartBar.style.display = 'none'; // Nascondi la barra quando sei sopra il form
          document.querySelector('.nobile-footer-wrapper').style.removeProperty('z-index');
        }
      }
    
      // Aggiungi un event listener allo scroll solo se il form esiste
      window.addEventListener('scroll', handleScroll);
    }
  
    /* GG MOD START - sync sticky add-to-cart variant with PDP selection */
    class NobileStickyAddToCartSync {
      constructor() {
        this.barSelector = '.nobile-sticky-add-to-cart';
        this.variantSelector = '.variant__selector';
        this.variantInputSelector = 'input[type="hidden"][name="id"]';
        this.productJsonSelector = '[data-product-json]';
        this.addButtonSelector = '[data-add-to-cart]';
        this.addButtonTextSelector = '[data-add-to-cart-text]';
        this.buttonPriceSelector = '[data-button-price]';
      }

      init() {
        this.bars().forEach((bar) => {
          this.syncFromCurrentFormValue(bar);
          this.bindStickySelect(bar);
        });

        document.addEventListener('theme:variant:change', (event) => {
          if (event.target && event.target.closest && event.target.closest(this.barSelector)) return;
          const variant = event.detail && event.detail.variant ? event.detail.variant : null;
          this.bars().forEach((bar) => this.updateBar(bar, variant));
        });
      }

      bars() {
        return Array.from(document.querySelectorAll(this.barSelector));
      }

      bindStickySelect(bar) {
        const selector = bar.querySelector(this.variantSelector);
        if (!selector || selector.dataset.nobileStickyVariantBound === 'true') return;
        selector.dataset.nobileStickyVariantBound = 'true';
        selector.addEventListener('change', () => {
          const variant = this.findVariantById(bar, selector.value);
          this.updateBar(bar, variant, { skipSelect: true });
        });
      }

      syncFromCurrentFormValue(bar) {
        const variantInput = bar.querySelector(this.variantInputSelector);
        const variant = variantInput ? this.findVariantById(bar, variantInput.value) : null;
        this.updateBar(bar, variant);
      }

      updateBar(bar, variant, options = {}) {
        const selector = bar.querySelector(this.variantSelector);
        const variantInput = bar.querySelector(this.variantInputSelector);
        const addButton = bar.querySelector(this.addButtonSelector);
        const addButtonText = bar.querySelector(this.addButtonTextSelector);
        const buttonPrice = bar.querySelector(this.buttonPriceSelector);

        if (variant && variant.id) {
          const variantId = String(variant.id);
          if (selector && !options.skipSelect) selector.value = variantId;
          if (variantInput) variantInput.value = variantId;
          if (addButton) addButton.disabled = !variant.available;
          if (addButtonText) addButtonText.textContent = variant.available ? this.addToCartText() : this.soldOutText();
          if (buttonPrice) buttonPrice.textContent = this.formatMoney(variant.price);
        } else {
          if (variantInput) variantInput.value = '';
          if (addButton) addButton.disabled = true;
          if (addButtonText) addButtonText.textContent = this.unavailableText();
          if (buttonPrice) buttonPrice.textContent = '';
        }
      }

      findVariantById(bar, id) {
        const product = this.productJson(bar);
        if (!product || !Array.isArray(product.variants)) return null;
        return product.variants.find((variant) => String(variant.id) === String(id)) || null;
      }

      productJson(bar) {
        if (bar._nobileStickyProductJson) return bar._nobileStickyProductJson;
        const jsonEl = bar.querySelector(this.productJsonSelector);
        if (!jsonEl) return null;
        try {
          bar._nobileStickyProductJson = JSON.parse(jsonEl.textContent);
          return bar._nobileStickyProductJson;
        } catch (error) {
          console.warn('[NobileStickyAddToCartSync] Invalid product JSON', error);
          return null;
        }
      }

      formatMoney(price) {
        const formatter = window.themeVendor && window.themeVendor.themeCurrency && window.themeVendor.themeCurrency.formatMoney
          ? window.themeVendor.themeCurrency.formatMoney
          : window.themeCurrency && window.themeCurrency.formatMoney;

        if (!formatter || !window.theme) return '';

        const formatted = formatter(price, window.theme.moneyFormat);
        return window.theme.settings && window.theme.settings.currency_code_enable
          ? `${formatted} ${window.theme.currencyCode}`
          : formatted;
      }

      addToCartText() {
        return window.theme && window.theme.strings && window.theme.strings.addToCart
          ? window.theme.strings.addToCart
          : 'Add to cart';
      }

      soldOutText() {
        return window.theme && window.theme.strings && window.theme.strings.soldOut
          ? window.theme.strings.soldOut
          : 'Sold out';
      }

      unavailableText() {
        return window.theme && window.theme.strings && window.theme.strings.unavailable
          ? window.theme.strings.unavailable
          : 'Unavailable';
      }
    }

    const nobileStickyAddToCartSync = new NobileStickyAddToCartSync();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => nobileStickyAddToCartSync.init());
    } else {
      nobileStickyAddToCartSync.init();
    }
    /* GG MOD END */
  
    /* GG MOD START - animazione progress bar v2: riempimento tacche e scorrimento alla finestra successiva */
    // La barra (snippets/cart-shipping-bar-v2.liquid) è rirenderizzata via AJAX, quindi il DOM è sempre nuovo:
    // ricordiamo l'ultimo conteggio per gruppo e, quando una barra nuova sale di livello, riproduciamo la transizione.
    class NobileProgressBarAnimator {
      constructor() {
        this.stepSize = 6;
        this.fillStepMs = 140;
        this.fillMs = 280;
        this.holdMs = 700;
        this.slideMs = 700;
        this.lastCount = {};
        this.lastIncluded = {};
        this.pending = {};
        this.seen = new WeakSet();
      }

      init() {
        if (!document.body || typeof MutationObserver === 'undefined') return;
        this.reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
        document.querySelectorAll('.pbar2').forEach((bar) => {
          this.seen.add(bar);
          this.lastCount[bar.dataset.pbar2Group] = this.countOf(bar);
          this.lastIncluded[bar.dataset.pbar2Group] = this.hasIncluded(bar);
        });
        new MutationObserver((records) => this.onMutations(records)).observe(document.body, { childList: true, subtree: true });
      }

      hasIncluded(bar) {
        const el = bar.querySelector('.pbar2__included');
        return !!(el && el.textContent.trim());
      }

      countOf(bar) {
        return parseInt(bar.dataset.pbar2Count, 10) || 0;
      }

      onMutations(records) {
        const bars = [];
        let removedBars = false;
        records.forEach((record) => {
          record.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            const found = node.matches('.pbar2') ? [node] : Array.from(node.querySelectorAll('.pbar2'));
            found.forEach((bar) => {
              if (!this.seen.has(bar)) {
                this.seen.add(bar);
                bars.push(bar);
              }
            });
          });
          record.removedNodes.forEach((node) => {
            if (node.nodeType === 1 && (node.matches('.pbar2') || node.querySelector('.pbar2'))) removedBars = true;
          });
        });

        bars.forEach((bar) => this.onBar(bar));

        // gruppi scomparsi dal carrello: il prossimo ingresso riparte senza animazione
        if (removedBars) {
          Object.keys(this.lastCount).forEach((group) => {
            if (!document.querySelector('.pbar2[data-pbar2-group="' + group + '"]')) {
              delete this.lastCount[group];
              delete this.lastIncluded[group];
              delete this.pending[group];
            }
          });
        }
      }

      onBar(bar) {
        const group = bar.dataset.pbar2Group;
        const count = this.countOf(bar);
        // se la barra è stata sostituita a metà animazione con lo stesso conteggio, riparte dalla stessa origine
        const pending = this.pending[group];
        const prev = pending && pending.to === count ? pending.from : this.lastCount[group];
        this.lastCount[group] = count;
        const hadIncluded = this.lastIncluded[group];
        this.lastIncluded[group] = this.hasIncluded(bar);
        if (pending && pending.to !== count) delete this.pending[group];

        if (prev === undefined || count <= prev || this.reducedMotion.matches) return;

        const steps = bar.querySelector('.pbar2__steps');
        if (!steps) return;

        const size = this.stepSize;
        const prevWindow = Math.floor(prev / size);
        const prevPos = prev % size;
        const window_ = Math.floor(count / size);
        const pos = count % size;

        this.pending[group] = { from: prev, to: count };
        const done = () => {
          if (bar.isConnected && this.pending[group] && this.pending[group].to === count) delete this.pending[group];
        };

        if (window_ === prevWindow) {
          this.fill(steps, prevPos, pos);
          setTimeout(done, (pos - prevPos) * this.fillStepMs + this.fillMs);
        } else {
          this.slide(bar, steps, prevWindow, prevPos, pos, done, !hadIncluded);
        }
      }

      // Svuota le tacche from..to-1 (già renderizzate piene) e le riempie in sequenza.
      fill(steps, from, to) {
        const ticks = Array.from(steps.querySelectorAll('.pbar2__step'));
        for (let i = from; i < to; i++) {
          ticks[i].classList.remove('is-filled');
          ticks[i].querySelector('.pbar2__tick').style.transitionDelay = ((i - from) * this.fillStepMs) + 'ms';
        }
        void steps.offsetWidth;
        for (let i = from; i < to; i++) ticks[i].classList.add('is-filled');
      }

      slide(bar, steps, prevWindow, prevPos, pos, done, hideIncluded) {
        const size = this.stepSize;
        const track = bar.querySelector('.pbar2__track');
        if (!track) return;

        // pannello A = finestra precedente, clonata dalla nuova e riportata allo stato di prima
        const panelA = steps.cloneNode(true);
        const firstOld = prevWindow * size + 1;
        panelA.querySelectorAll('.pbar2__step').forEach((step, i) => {
          if (i < size - 1) step.querySelector('.pbar2__num').textContent = firstOld + i;
          step.classList.toggle('is-filled', i < prevPos);
          step.querySelector('.pbar2__tick').style.transitionDelay = '';
        });
        panelA.querySelector('.pbar2__half--left').classList.toggle('is-hidden', prevWindow === 0);

        // pannello B = nuova finestra, vuota finché non è visibile
        steps.querySelectorAll('.pbar2__step').forEach((step) => step.classList.remove('is-filled'));

        // la riga "include…" resta visibile se c'era già; se compare ora, rientra alla fine
        bar.classList.add('is-animating');
        bar.classList.toggle('is-animating-new-included', !!hideIncluded);
        track.insertBefore(panelA, steps);
        void track.offsetWidth;

        this.fill(panelA, prevPos, size);
        const fillTotal = (size - prevPos - 1) * this.fillStepMs + this.fillMs;

        setTimeout(() => {
          if (!bar.isConnected) return;
          track.style.transform = 'translateX(-100%)';

          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            if (!bar.isConnected) return;
            track.style.transition = 'none';
            panelA.remove();
            track.style.transform = '';
            void track.offsetWidth;
            track.style.transition = '';
            bar.classList.remove('is-animating', 'is-animating-new-included');
            if (pos > 0) this.fillNew(steps, pos);
            done();
          };
          track.addEventListener('transitionend', (e) => {
            if (e.target === track && e.propertyName === 'transform') finish();
          });
          setTimeout(finish, this.slideMs + 150);
        }, fillTotal + this.holdMs);
      }

      // le tacche della nuova finestra sono state svuotate durante lo scorrimento: le riempie ora
      fillNew(steps, pos) {
        const ticks = Array.from(steps.querySelectorAll('.pbar2__step'));
        for (let i = 0; i < pos; i++) {
          ticks[i].querySelector('.pbar2__tick').style.transitionDelay = (i * this.fillStepMs) + 'ms';
        }
        void steps.offsetWidth;
        for (let i = 0; i < pos; i++) ticks[i].classList.add('is-filled');
      }
    }

    const nobileProgressBarAnimator = new NobileProgressBarAnimator();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => nobileProgressBarAnimator.init());
    } else {
      nobileProgressBarAnimator.init();
    }
    /* GG MOD END */

    document.addEventListener('theme:cart:change', function(event) {
      var cart = event.detail.cart;

      /* GG MOD START  - avvio AIOD solo se app rilevata */
      // Force AIOD to start/restart on every cart change
      if (nobileCartDiscountsWatcher.hasAiodApp() && window.csappsStart) {
        //console.log('🚀 Force calling csappsStart() on cart change...');
        try {
          window.csappsStart();
        } catch (error) {
          //console.log('⚠️ csappsStart() failed:', error);
        }
      }
      /* GG MOD END */
      
      // Wait for AIOD to initialize, then process discounts
      setTimeout(() => nobileCartDiscountsWatcher.cartChanged(cart), 3000);
      //nobileCartDiscountsWatcher.cartChanged(cart);
  
      if (cart) {
        // console.log('Cart ———————————— ↓');
        // console.log(cart);
        // ... update shipping bar in cart drawer
        window.fetch(`${window.theme.routes.root_url}?section_id=api-shipping-bar`).then((response)=>{
            return response.text();
        }).then((response)=>{
            const fresh = document.createElement('div');
            fresh.innerHTML = response;
            document.querySelector('[data-shipping-bar]').innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
        })
        .catch(error => {
          // Handle any errors that occurred during the fetch
          console.error('Fetch error:', error);
        });
        
      }
    });
  
    
    // Fired when page loads to update header values
    document.addEventListener('theme:cart:init', (e) => {
      // console.log('theme:cart:init');
      // console.log(e);
    });
  
    // Debounced scroll listeners.  Up and down only fire on direction changes
    // These events are useful for creating sticky elements and popups.
    // document.addEventListener('theme:scroll', e => { console.log(e); });
    // document.addEventListener('theme:scroll:up', e => { console.log(e); });
    // document.addEventListener('theme:scroll:down', e => { console.log(e); });
  
    // Debounced resize listener to bundle changes that trigger document reflow
    // document.addEventListener('theme:resize', e => { console.log(e); });
  
    // Locks and unlocks page scroll for modals and drawers
    // These are commented out because firing them will lock the page scroll
    // the lock event must set `detail` to the modal or drawer body so the 
    // scroll locking code knows what element should maintain scoll. 
    // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
    // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  
  /*
  * Enhanced Related Products Popup
  *
  * This code improves the existing popup by adding size selection functionality
  * before products can be added to cart.
  */
  /* GG MOD START - upsell a slot configurabili: i pool per categoria sono sostituiti
     dagli slot di sections/cart-upsell-config.liquid (vedi resolveCartUpsellSlot) */
  /* GG MOD END */

  let popupIsOpen = false;
  let latestRelatedProductsCart = null;
  /* GG MOD START - cart upsell popup requires visible cart drawer */
  let relatedProductsPopupTimer = null;
  let relatedProductsAnimationTimer = null;
  /* GG MOD END */

  const currentLocale = document.documentElement.lang || 'it';
  const localePrefix = (currentLocale === 'it') ? '' : `/${currentLocale}`;
  
  // Add this function to detect user's country
  // Check if Shopify's global objects provide geolocation
  function getUserCountry() {
    // Check Shopify's country code
    if (window.Shopify && window.Shopify.country) {
      const countryCode = window.Shopify.country;
      return getFullCountryName(countryCode);
    }
  
    // Fallback methods
    const browserLanguage = navigator.language || navigator.userLanguage;
    const countryFromLanguage = browserLanguage.split('-')[1];
  
    if (countryFromLanguage) {
      return getFullCountryName(countryFromLanguage);
    }
  
    return null;
  }
  
  // Add a list of European countries where we want to show perfume
  const europeanCountriesList = [
    'Italy', 'Germany', 'Austria', 'France', 'Netherlands', 
    'Belgium', 'Spain', 'Portugal', 'Czech Republic', 'Slovakia', 
    'Hungary', 'Poland', 'Croatia', 'Slovenia', 'Romania', 
    'Bulgaria', 'Denmark', 'Finland', 'Sweden', 'Greece', 
    'Switzerland', 'Lithuania', 'Latvia', 'Estonia'
  ];
  
  function getFullCountryName(countryCode) {
    const countryNames = {
      // European Countries
      'IT': 'Italy',
      'DE': 'Germany',
      'AT': 'Austria',
      'FR': 'France',
      'NL': 'Netherlands',
      'BE': 'Belgium',
      'ES': 'Spain',
      'PT': 'Portugal',
      'CZ': 'Czech Republic',
      'SK': 'Slovakia',
      'HU': 'Hungary',
      'PL': 'Poland',
      'HR': 'Croatia',
      'SI': 'Slovenia',
      'RO': 'Romania',
      'BG': 'Bulgaria',
      'DK': 'Denmark',
      'FI': 'Finland',
      'SE': 'Sweden',
      'GR': 'Greece',
      'CH': 'Switzerland',
      'LT': 'Lithuania',
      'LV': 'Latvia',
      'EE': 'Estonia',
      'GB': 'United Kingdom'
    };
  
    return countryNames[countryCode.toUpperCase()] || countryCode;
  }
    
  // Function to check if user is from one of our target European countries
  function isFromTargetEuropeanCountry(country) {
    // GG MOD START - show perfume only when the country is explicitly allowed
    if (!country) {
      return false;
    }
    // GG MOD END
    const cartUpsellData = window.nobileCartUpsellData || {};
    const countriesWithPerfume = Array.isArray(cartUpsellData.countriesWithPerfume)
      ? cartUpsellData.countriesWithPerfume
      : europeanCountriesList;
    return countriesWithPerfume.includes(country);
  }
    
  (function() {
    // Initialize the popup when the DOM is loaded
    document.addEventListener('DOMContentLoaded', function() {
      initRelatedProductsPopup();
    });

    function rememberRelatedProductsCart(cart) {
      if (cart && Array.isArray(cart.items)) {
        latestRelatedProductsCart = cart;
      }
      return latestRelatedProductsCart;
    }

    async function getRelatedProductsCart(allowFetch = true) {
      if (latestRelatedProductsCart && Array.isArray(latestRelatedProductsCart.items)) {
        return latestRelatedProductsCart;
      }

      if (!allowFetch) {
        return null;
      }

      const cart = await fetch('/cart.js').then(response => response.json());
      return rememberRelatedProductsCart(cart);
    }

    /* GG MOD START - upsell a slot configurabili (statico / dinamico uomo-donna / intimo) */
    function getCartUpsellData() {
      const data = window.nobileCartUpsellData || {};
      return {
        collections: data.collections || {},
        slots: Array.isArray(data.slots) ? data.slots : [],
        perfume: data.perfume || null
      };
    }

    function isAvailableUpsellProduct(product) {
      return Boolean(
        product &&
        product.available === true &&
        Array.isArray(product.variants) &&
        product.variants.some(variant => variant.available === true)
      );
    }

    function cloneUpsellProduct(product, slot) {
      const badge = slot && slot.badge ? slot.badge : null;
      return Object.assign({}, product, {
        slotKey: slot ? slot.key : null,
        isGiftIdea: Boolean(badge),
        giftLabel: badge,
        images: Array.isArray(product.images) ? product.images.slice() : [],
        variants: Array.isArray(product.variants) ? product.variants.slice() : [],
        options: Array.isArray(product.options) ? product.options.slice() : []
      });
    }

    /* Id prodotto che una scheda occupa: la scheda intimo li occupa tutti i suoi modelli. */
    function getUpsellCardProductIds(card) {
      if (!card || !card.models) return card ? [String(card.id)] : [];
      return card.models.map(model => String(model.product.id));
    }

    /*
     * Risolve uno slot nella scheda da mostrare.
     * ctx.cartProductIds: prodotti già nel carrello (esclusi, tranne che nella scheda intimo)
     * ctx.excludedIds: prodotti già mostrati da altri slot
     * ctx.isWomen: il primo prodotto del carrello è da donna
     */
    function resolveCartUpsellSlot(slot, ctx) {
      if (!slot) return null;

      if (slot.mode === 'underwear') {
        // I modelli restano proponibili anche se già nel carrello: si può volere un altro colore o taglia.
        const models = (slot.models || []).filter(model =>
          model && isAvailableUpsellProduct(model.product) &&
          !ctx.excludedIds.has(String(model.product.id))
        );
        if (!models.length) return null;

        return Object.assign(cloneUpsellProduct(models[0].product, slot), {
          kind: 'underwear',
          models: models
        });
      }

      const candidates = slot.mode === 'dynamic'
        ? (ctx.isWomen ? slot.women : slot.men)
        : slot.candidates;

      const product = (candidates || []).find(candidate =>
        isAvailableUpsellProduct(candidate) &&
        !ctx.cartProductIds.has(String(candidate.id)) &&
        !ctx.excludedIds.has(String(candidate.id))
      );

      return product ? cloneUpsellProduct(product, slot) : null;
    }
    /* GG MOD END */

    /* GG MOD START - cart upsell popup requires visible cart drawer */
    function clearRelatedProductsPopupTimer() {
      if (relatedProductsPopupTimer) {
        clearTimeout(relatedProductsPopupTimer);
        relatedProductsPopupTimer = null;
      }
    }

    function clearRelatedProductsAnimationTimer() {
      if (relatedProductsAnimationTimer) {
        clearTimeout(relatedProductsAnimationTimer);
        relatedProductsAnimationTimer = null;
      }
    }

    function scheduleRelatedProductsPopup(cart = null) {
      clearRelatedProductsPopupTimer();
      relatedProductsPopupTimer = setTimeout(function() {
        relatedProductsPopupTimer = null;

        if (!isCartDrawerOpen()) {
          return;
        }

        showRelatedProducts(cart).catch(function(error) {
          console.error('Error showing related products:', error);
        });
      }, 800);
    }
    /* GG MOD END */
    
    function initRelatedProductsPopup() {
      //console.log('Initializing related products popup');
      
      // Create popup HTML if it doesn't exist
      if (!document.getElementById('related-products-popup')) {
        createPopupHTML();
      }
      
      // Keep track of cart item count
      let previousCartItemCount = 0;
      let initialCountLoaded = false;
      // close popup when cart is closed
      document.addEventListener('theme:scroll:unlock', function() {
        /* GG MOD START - cart upsell popup requires visible cart drawer */
        clearRelatedProductsPopupTimer();
        /* GG MOD END */
        if (popupIsOpen) {
          //console.log('Cart closed (scroll unlocked), hiding related products popup');
          hideRelatedProductsPopup();
        }
      });

      /* GG MOD START - cart upsell popup requires visible cart drawer */
      const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (cartDrawer) {
        cartDrawer.addEventListener('theme:drawer:close', function() {
          clearRelatedProductsPopupTimer();
          if (popupIsOpen) {
            hideRelatedProductsPopup();
          }
        });
      }
      /* GG MOD END */

      // Listen for cart changes
      document.addEventListener('theme:cart:change', function(event) {
        if (event.detail && event.detail.cart) {
          rememberRelatedProductsCart(event.detail.cart);
          const currentCartItemCount = event.detail.cart.item_count || 0;

          // Only show popup if item count has increased (something was added)
          // AND the popup is not already open
          // AND the initial count baseline has been loaded (avoids race condition on page load)
          if (initialCountLoaded && currentCartItemCount > previousCartItemCount && !popupIsOpen) {
            //console.log('Item added to cart, showing related products popup');
            // Show popup with a slight delay to let cart drawer open first
            /* GG MOD START - cart upsell popup requires visible cart drawer */
            scheduleRelatedProductsPopup(event.detail.cart);
            /* GG MOD END */
          }

          // Update the previous count for next comparison
          previousCartItemCount = currentCartItemCount;
        }
      });
      
      // Simple solution that listens for the scroll lock event when cart opens
      document.addEventListener('theme:scroll:lock', function(event) {
        // Only proceed if popup isn't already open
        if (!popupIsOpen) {
          // Check if the event is related to the cart drawer
          // The event.detail will contain the element being locked for scrolling
          if (event.detail && 
              (event.detail.closest('[data-drawer="drawer-cart"]') || 
               event.detail.closest('.cart__drawer'))) {
            
            // Wait for the cart to be fully visible
            /* GG MOD START - cart upsell popup requires visible cart drawer */
            scheduleRelatedProductsPopup();
            /* GG MOD END */
          }
        }
      });
      
      // Initialize the previous count when the page loads
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          rememberRelatedProductsCart(cart);
          previousCartItemCount = cart.item_count || 0;
          initialCountLoaded = true;
          //console.log('Initial cart item count:', previousCartItemCount);
        })
        .catch(error => console.error('Error fetching initial cart:', error));
    }
    
    function createPopupHTML() {
      // Remove any existing popup to avoid duplicates
      const existingPopup = document.getElementById('related-products-popup');
      if (existingPopup) {
        existingPopup.remove();
      }
  
        // Add translations retrieval here, at the start of the function
      const translations = window.themeTranslations?.relatedProducts || {
        title: "COMPLETE YOUR LOOK",
        subtitle: "Find out how to take care of it and add some accessories.",
        giftIdea: "Gift Idea",
        selectSize: "Select Size",
        size: "Size",
        shoeSize: "Shoe size",
        addToCart: "Add to Cart",
        outOfStock: "Out of Stock",
        pleaseSelectSize: "Please select a size",
        adding: "Adding...",
        added: "Added!"
      };
      
      // Create new popup without background overlay
      const popup = document.createElement('div');
      popup.id = 'related-products-popup';
      popup.style.position = 'fixed';
      popup.style.top = '0';
      popup.style.left = '0';
      popup.style.width = '100%';
      popup.style.height = '100%';
      popup.style.zIndex = '99998';
      popup.style.display = 'none';
      popup.style.pointerEvents = 'none'; // Important: allows clicks to pass through
      
      // Create the container - centered
      const containerDiv = document.createElement('div');
      containerDiv.id = 'related-products-container';
      containerDiv.style.backgroundColor = 'white';
      containerDiv.style.position = 'absolute';
      containerDiv.style.top = '50%';
      containerDiv.style.left = '35%'; // Moved more to the right
      containerDiv.style.transform = 'translate(-50%, -50%) scale(0.9)';
      containerDiv.style.width = '880px';
      containerDiv.style.maxWidth = '75vw';
      containerDiv.style.maxHeight = '90vh';
      containerDiv.style.zIndex = '99998';
      containerDiv.style.boxShadow = 'rgba(0, 0, 0, 0.15) 0px 0px 30px';
      containerDiv.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
      containerDiv.style.opacity = '0';
      containerDiv.style.pointerEvents = 'auto';
      containerDiv.style.display = 'flex';
      containerDiv.style.flexDirection = 'column';
      containerDiv.style.overflow = 'hidden';
      
      const headerDiv = document.createElement('div');
      headerDiv.style.padding = '25px 30px 20px';
      headerDiv.style.borderBottom = '1px solid #eee';
      headerDiv.style.backgroundColor = 'white';
      headerDiv.style.display = 'flex';
      headerDiv.style.justifyContent = 'center';
      headerDiv.style.alignItems = 'center';
      headerDiv.style.position = 'relative';
      
      const titleContainer = document.createElement('div');
      titleContainer.style.display = 'flex';
      titleContainer.style.flexDirection = 'column';
      titleContainer.style.textAlign = 'center';
      
      const titleElement = document.createElement('h2');
      titleElement.style.margin = '0';
      titleElement.style.fontSize = '24px';
      titleElement.style.fontWeight = '600';
      titleElement.style.color = '#003c74';
      titleElement.style.textTransform = 'uppercase';
      titleElement.textContent = translations.title;
      
      //const subtitleElement = document.createElement('p');
      //subtitleElement.style.margin = '8px 0 0';
      //subtitleElement.style.fontSize = '16px';
      //subtitleElement.style.color = '#666';
      //subtitleElement.textContent = translations.subtitle;
      
      titleContainer.appendChild(titleElement);
      //titleContainer.appendChild(subtitleElement);
      
      // Create close button (as an X in the top right)
      const closeButton = document.createElement('button');
      closeButton.id = 'close-related-popup-btn';
      closeButton.style.position = 'absolute';
      closeButton.style.top = '15px';
      closeButton.style.right = '15px';
      closeButton.style.background = 'none';
      closeButton.style.border = 'none';
      closeButton.style.cursor = 'pointer';
      closeButton.style.fontSize = '28px';
      closeButton.style.fontWeight = '300';
      closeButton.style.color = '#999';
      closeButton.style.zIndex = '10';
      closeButton.innerHTML = '&times;';
      
      const contentDiv = document.createElement('div');
      contentDiv.id = 'related-products-content';
      contentDiv.style.padding = '20px 30px';
      contentDiv.style.flex = '1';
      contentDiv.style.overflowY = 'auto';
      contentDiv.style.overflowX = 'hidden';
      contentDiv.style.display = 'grid';
      contentDiv.style.gridTemplateColumns = 'repeat(3, 1fr)';
      contentDiv.style.gap = '15px';
      contentDiv.style.backgroundColor = 'white';
      contentDiv.innerHTML = '<p style="grid-column: span 3; color: #666; text-align: center; padding: 40px 0;">Loading recommendations...</p>';
      
      // Assemble the popup elements
      headerDiv.appendChild(titleContainer);
      
      containerDiv.appendChild(headerDiv);
      containerDiv.appendChild(contentDiv);
      containerDiv.appendChild(closeButton);
      
      popup.appendChild(containerDiv);
      
      // Add to document
      document.body.appendChild(popup);
      
      // Add event listener to the close button
      closeButton.addEventListener('click', function() {
        hideRelatedProductsPopup();
      });
      
      //console.log('Popup created successfully:', popup);
      return popup;
    }
    
    function hideRelatedProductsPopup() {
      popupIsOpen = false;
      /* GG MOD START - cart upsell popup requires visible cart drawer */
      clearRelatedProductsAnimationTimer();
      /* GG MOD END */
      const popup = document.getElementById('related-products-popup');
      const container = document.getElementById('related-products-container');
      
      if (container) {
        container.style.opacity = '0';
        container.style.transform = 'translate(-50%, -50%) scale(0.9)';
      }
      
      // Delay hiding the popup until after the animation
      setTimeout(function() {
        if (popup) {
          popup.style.display = 'none';
          
          // Make sure pointer-events is set to none
          popup.style.pointerEvents = 'none';
          
          // Reset any z-index changes that might have occurred
          popup.style.zIndex = '90000';
          
          // Ensure the body can receive pointer events
          document.body.style.pointerEvents = 'auto';
          
          // Log that cleanup has been done
          //console.log('Popup hidden and pointer events reset');
        }
      }, 300);
    }
    
    // Updated showRelatedProducts function
    async function showRelatedProducts(cart = null) {
  
      // Don't show desktop popup on mobile devices
      if (window.innerWidth <= 768) {
        //console.log('On mobile device, not showing desktop popup');
        return;
      }

      if (!isCartDrawerOpen()) {
        return;
      }
      
      // First, check if we have items in the cart
      cart = rememberRelatedProductsCart(cart) || await getRelatedProductsCart(true);
      
      if (!cart || !cart.items || cart.items.length === 0) {
        //console.log('Cart is empty, not showing popup');
        /* GG MOD START - cart upsell popup requires visible cart drawer */
        popupIsOpen = false;
        /* GG MOD END */
        return;
      }

      //console.log('Showing related products popup');
      popupIsOpen = true;
      
      // Shopify returns cart.items in reverse chronological order: index 0 is the most recently added item.
      // Using the last array item here intentionally selects the first product added to the cart.
      const firstItem = cart.items[cart.items.length - 1];
      //console.log('First item in cart:', firstItem);
      
      // Check if this item is in the men's or women's collection
      let isMensProduct = checkIfProductInCollection(firstItem.handle, 'klaviyo-uomo', firstItem.product_id);
      const isWomensProduct = checkIfProductInCollection(firstItem.handle, 'klaviyo-donna', firstItem.product_id);
      
      //console.log('Is men\'s product?', isMensProduct, 'Is women\'s product?', isWomensProduct);
      
      // If it's neither a men's nor women's product, don't show the popup
      if (!isMensProduct && !isWomensProduct) {
        //console.log('Product is neither men\'s nor women\'s, treating as men\'s product');
        // Don't return, continue showing the popup with men's recommendations
        isMensProduct = true; // Force it to be treated as a men's product
      }
      
      // Set a flag to track which type of products to show
      window.showingWomensProducts = isWomensProduct;
      
      let popup = document.getElementById('related-products-popup');
      let container = document.getElementById('related-products-container');
      
      // If popup doesn't exist, create it
      if (!popup || !container) {
        //console.log('Creating popup as it was not found');
        popup = createPopupHTML();
        container = document.getElementById('related-products-container');
        
        // Double check after creation
        if (!popup || !container) {
          console.error('Failed to create popup elements');
          return;
        }
      }

      if (!isCartDrawerOpen()) {
        popupIsOpen = false;
        return;
      }
      
      // Show the popup
      popup.style.display = 'block';
      popup.style.zIndex = '90000';
      
      // Make sure everything is rendered before animating
      /* GG MOD START - cart upsell popup requires visible cart drawer */
      relatedProductsAnimationTimer = setTimeout(function() {
        relatedProductsAnimationTimer = null;

        if (!isCartDrawerOpen()) {
          hideRelatedProductsPopup();
          return;
        }

        container.style.opacity = '1';
        container.style.transform = 'translate(-50%, -50%) scale(1)';
      }, 50);
      /* GG MOD END */
      
      // Fetch our custom products
      try {

        if (!isCartDrawerOpen()) {
          popupIsOpen = false;
          return;
        }

        const products = await fetchCustomProducts(cart);

        /* GG MOD START - cart upsell popup requires visible cart drawer */
        if (!isCartDrawerOpen()) {
          popupIsOpen = false;
          hideRelatedProductsPopup();
          return;
        }
        /* GG MOD END */

        renderProducts(products);
      } catch (error) {
        console.error('Error showing related products:', error);
        const contentElement = document.getElementById('related-products-content');
        if (contentElement) {
          contentElement.innerHTML = '<p style="grid-column: span 3; color: #666; text-align: center; padding: 40px 0;">Could not load related products.</p>';
        }
      }
    }

    function isCartDrawerOpen() {
      const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]') ||
                        document.querySelector('.cart__drawer') ||
                        document.querySelector('.drawer--cart');

      if (!cartDrawer) return false;

      // Pipeline theme aggiunge 'drawer--visible' solo quando il drawer è effettivamente aperto
      return cartDrawer.classList.contains('drawer--visible');
    }
  
    async function fetchCustomProducts(cart) {
      try {
        /* GG MOD START - upsell a slot configurabili (statico / dinamico uomo-donna / intimo) */
        const upsellData = getCartUpsellData();
        const cartItems = cart && Array.isArray(cart.items) ? cart.items : [];
        const ctx = {
          cartProductIds: new Set(cartItems.map(item => String(item.product_id))),
          excludedIds: new Set(),
          // Calcolato da showRelatedProducts / populateMobileUpsellProducts sul primo prodotto del carrello
          isWomen: window.showingWomensProducts === true
        };
        const selectedProducts = [];

        // Profumo: nei carrelli uomo prende il posto del primo slot, solo nei paesi in cui è spedibile
        let perfume = null;
        if (!ctx.isWomen && upsellData.perfume && upsellData.slots.length > 0) {
          const showPerfume = isFromTargetEuropeanCountry(getUserCountry());
          if (showPerfume &&
              isAvailableUpsellProduct(upsellData.perfume) &&
              !ctx.cartProductIds.has(String(upsellData.perfume.id))) {
            perfume = cloneUpsellProduct(upsellData.perfume, { key: upsellData.slots[0].key, badge: null });
          }
        }

        upsellData.slots.forEach((slot, index) => {
          const card = index === 0 && perfume ? perfume : resolveCartUpsellSlot(slot, ctx);
          if (!card) return;

          getUpsellCardProductIds(card).forEach(id => ctx.excludedIds.add(id));
          selectedProducts.push(card);
        });

        return {
          products: selectedProducts.slice(0, 3),
          currentProductInfo: null
        };
        /* GG MOD END */
      } catch (error) {
        console.error('Error in fetchCustomProducts:', error);
        return {
          products: [],
          currentProductInfo: null
        };
      }
    }
  
    // Helper function to check if a product is in a cached upsell collection
    function checkIfProductInCollection(productHandle, collectionHandle, productId = null) {
      const data = getCartUpsellData();
      const collections = data.collections || {};
      let collection = null;

      if (collectionHandle === 'klaviyo-uomo' || (collections.men && collectionHandle === collections.men.handle)) {
        collection = collections.men;
      } else if (collectionHandle === 'klaviyo-donna' || (collections.women && collectionHandle === collections.women.handle)) {
        collection = collections.women;
      }

      if (!collection) {
        return false;
      }

      const productIds = Array.isArray(collection.productIds) ? collection.productIds.map(id => String(id)) : [];
      const productHandles = Array.isArray(collection.productHandles) ? collection.productHandles : [];

      return (
        (productId && productIds.includes(String(productId))) ||
        (productHandle && productHandles.includes(productHandle))
      );
    }
    
    // Try to get the current product data and its selected variant
    function getCurrentProductInfo() {
      let productInfo = {
        handle: null,
        selectedVariant: null,
        variantColor: null
      };
      
      // Try to get from URL
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('variant')) {
        productInfo.selectedVariant = urlParams.get('variant');
      }
      
      // Try to get from meta tags
      const productHandleMeta = document.querySelector('meta[property="og:url"]');
      if (productHandleMeta) {
        const url = productHandleMeta.getAttribute('content');
        const urlParts = url.split('/');
        const productsIndex = urlParts.indexOf('products');
        if (productsIndex !== -1 && urlParts.length > productsIndex + 1) {
          productInfo.handle = urlParts[productsIndex + 1].split('?')[0];
        }
      }
      
      // Try to get variant color from form
      const variantColorField = document.querySelector('input[name="variant-color"], [data-option-color]');
      if (variantColorField) {
        productInfo.variantColor = variantColorField.value;
      }
      
      // Try to get from Shopify page object if available
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        const product = window.ShopifyAnalytics.meta.product;
        productInfo.handle = product.handle;
        
        // If we have a selected variant ID, try to find its color
        if (productInfo.selectedVariant && product.variants) {
          const variant = product.variants.find(v => v.id.toString() === productInfo.selectedVariant);
          if (variant) {
            // Try to find color from variant options
            const colorOptionIndex = product.options.findIndex(opt => 
              opt.name.toLowerCase().includes('color') || 
              opt.name.toLowerCase().includes('colour') ||
              opt.name.toLowerCase() === 'colore' // Italian
            );
            
            if (colorOptionIndex !== -1) {
              const optionPosition = colorOptionIndex + 1;
              productInfo.variantColor = variant[`option${optionPosition}`];
            }
          }
        }
      }
      
      return productInfo;
    }
    
    async function fetchRandomProducts() {
      try {
        // Try to get current product info
        const currentProduct = getCurrentProductInfo();
        
        //console.log('Current product info:', currentProduct);
        
        // Fetch products from a collection (using 'all' for simplicity)
        //console.log('Fetching products...');
        const response = await fetch(`${localePrefix}/collections/all/products.json?limit=15`);
        const data = await response.json();
        
        //console.log('API response received:', data);
        //console.log('Number of products returned:', data.products ? data.products.length : 0);
        
        if (data.products && data.products.length > 0) {
          // Log the first product to see its structure
          //console.log('First product sample:', JSON.stringify(data.products[0], null, 2));
        }
        
        // Get random selection of products
        const shuffled = data.products.sort(() => 0.5 - Math.random());
        
        // Filter products with variants that have valid options
        const filteredProducts = shuffled.filter(product => {
          return product.variants && 
                 product.variants.length > 0 && 
                 product.variants[0].id;
        });
        
        // Take first 6 for the grid
        return {
          products: filteredProducts.slice(0, 3),
          currentProductInfo: currentProduct
        };
      } catch (error) {
        console.error('Error fetching products:', error);
        return {
          products: [],
          currentProductInfo: null
        };
      }
    }
    
    function renderProducts(productsData) {
      const container = document.getElementById('related-products-content');
      if (!container) return;
      
      const { products } = productsData;
      
      if (!products || products.length === 0) {
        container.innerHTML = '<p style="grid-column: span 3; color: #666; text-align: center; padding: 40px 0;">No products found</p>';
        return;
      }
      
      // Clear existing content
      container.innerHTML = '';
      
      // Create grid layout for up to 3 products
      const maxProducts = Math.min(products.length, 3);
      for (let i = 0; i < maxProducts; i++) {
        const product = products[i];
        const productElement = createProductCard(product, i);
        container.appendChild(productElement);
      }
      fireUpsellViewItemList(products.slice(0, maxProducts));
    }

    /* GG MOD START */
    function fireUpsellViewItemList(products) {
      if (!window.gtag || !products || !products.length) return;
      gtag('event', 'view_item_list', {
        item_list_id: 'cart_upsell',
        item_list_name: 'Cart Upsell',
        items: products.map(function(p, i) {
          return {
            item_id: String(p.id),
            item_name: p.title || '',
            item_list_id: 'cart_upsell',
            item_list_name: 'Cart Upsell',
            index: i,
            price: p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0
          };
        })
      });
    }
    /* GG MOD END */

    function createProductCard(product, slotIndex = 0) {
      /* GG MOD START - upsell a slot configurabili: scheda intimo dedicata */
      if (product.kind === 'underwear') {
        return createUnderwearUpsellCard(product, slotIndex, false);
      }
      /* GG MOD END */
      // Add translations retrieval here, at the start of the function
      const translations = window.themeTranslations?.relatedProducts || {
        giftIdea: "Gift Idea",
        selectSize: "Select Size",
        size: "Size", 
        shoeSize: "Shoe size",
        addToCart: "Add to Cart",
        outOfStock: "Out of Stock",
        pleaseSelectSize: "Please select a size",
        adding: "Adding...",
        added: "Added!"
      };
      
      // Get price from the first variant instead of the product level
      let price = '—';
      let compareAtPrice = null;
      
      // Check if we have variants with price data
      if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        
        // Get price from variant
        if (firstVariant.price) {
          const priceValue = parseFloat(firstVariant.price);
          if (!isNaN(priceValue)) {
            price = priceValue.toFixed(2);
          }
        }
        
        // Get compare_at_price from variant
        if (firstVariant.compare_at_price) {
          const compareValue = parseFloat(firstVariant.compare_at_price);
          if (!isNaN(compareValue) && compareValue > 0) {
            compareAtPrice = compareValue.toFixed(2);
          }
        }
      }
      
      const imageSrc = product.images && product.images.length > 0 
        ? product.images[0].src 
        : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-image.png';
      
      // Create product element
      const productElement = document.createElement('div');
      productElement.classList.add('popup-product-card');
      productElement.style.display = 'flex';
      productElement.style.flexDirection = 'column';
      productElement.style.justifyContent = 'space-between';
      productElement.style.height = '100%';
      productElement.style.padding = '15px';
      productElement.style.border = '1px solid #eee';
      productElement.style.backgroundColor = 'white';
      productElement.setAttribute('data-product-handle', product.handle);
      productElement.setAttribute('data-slot-position', slotIndex);
      productElement.setAttribute('data-product-id', product.id);
      productElement.setAttribute('data-product-title', product.title || '');
      productElement.setAttribute('data-product-price',
        product.variants && product.variants[0] ? product.variants[0].price : 0);
      /* GG MOD START - upsell a slot configurabili: slot di provenienza della scheda */
      if (product.slotKey) productElement.setAttribute('data-slot-key', product.slotKey);
      /* GG MOD END */

      // Create image container with clickable link to product
      const imageContainer = document.createElement('a');
      imageContainer.href = '/products/' + product.handle; // Make image clickable to product page
      imageContainer.style.display = 'block';
      imageContainer.style.marginBottom = '15px';
      imageContainer.style.height = '180px';
      imageContainer.style.display = 'flex';
      imageContainer.style.justifyContent = 'center';
      imageContainer.style.alignItems = 'center';
      imageContainer.style.backgroundColor = 'white';
      imageContainer.style.cursor = 'pointer';
      productElement.style.position = 'relative'; // For positioning the ribbon
      imageContainer.style.position = 'relative'; // For positioning the ribbon
      
      // If the product is a gift idea, add a ribbon
      if (product.isGiftIdea) {
        const ribbon = document.createElement('div');
        ribbon.style.position = 'absolute';
        ribbon.style.top = '10px';
        ribbon.style.right = '-8px';
        ribbon.style.backgroundColor = '#e36f1a'; // Orange color
        ribbon.style.color = 'white';
        ribbon.style.padding = '5px 15px';
        ribbon.style.fontWeight = 'bold';
        ribbon.style.fontSize = '12px';
        ribbon.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
        ribbon.style.zIndex = '2';
        ribbon.style.transform = 'rotate(0deg)';
        /* GG MOD START - testo badge configurabile dall'editor */
        ribbon.textContent = product.giftLabel || translations.giftIdea;
        /* GG MOD END */
        
        // Create a small triangle for the ribbon tail effect
        const ribbonTail = document.createElement('div');
        ribbonTail.style.position = 'absolute';
        ribbonTail.style.top = '100%';
        ribbonTail.style.right = '0';
        ribbonTail.style.width = '8px';
        ribbonTail.style.height = '8px';
        ribbonTail.style.backgroundColor = '#b35511'; // Darker orange for the "tail"
        ribbonTail.style.clipPath = 'polygon(0 0, 100% 0, 100% 100%)';
        
        ribbon.appendChild(ribbonTail);
        imageContainer.appendChild(ribbon);
      }
      
      
      // Create image
      const image = document.createElement('img');
      image.src = imageSrc;
      image.alt = product.title || 'Product';
      image.style.maxWidth = '100%';
      image.style.maxHeight = '100%';
      image.style.objectFit = 'contain';
      
      // Create title with link
      const titleLink = document.createElement('a');
      titleLink.href = '/products/' + product.handle;
      titleLink.style.textDecoration = 'none';
      titleLink.style.color = '#003c74';
      titleLink.style.cursor = 'pointer';
      
      const title = document.createElement('h3');
      title.textContent = product.title || 'Product';
      title.style.fontSize = '16px';
      title.style.fontWeight = '500';
      title.style.margin = '0 0 6px';
      title.style.color = 'inherit';
      
      titleLink.appendChild(title);
      
      // Create product type - hide if it's "PRODUCT"
      const productType = document.createElement('p');
      productType.textContent = product.product_type || 'Product';
      productType.style.fontSize = '14px';
      productType.style.fontWeight = 'normal';
      productType.style.margin = '0 0 10px';
      productType.style.color = '#666';
      productType.style.textTransform = 'uppercase';
      
      // Add this condition to hide PRODUCT text
      if (!productType.textContent || productType.textContent.trim().toUpperCase() === 'PRODUCT') {
        productType.style.display = 'none';
      }
      
      // Create price container
      const priceContainer = document.createElement('div');
      priceContainer.style.display = 'flex';
      priceContainer.style.alignItems = 'center';
      priceContainer.style.marginBottom = '15px';
      
      // Create price
      const priceElement = document.createElement('span');
      priceElement.textContent = themeVendor.themeCurrency.formatMoney(parseFloat(price) * 100, theme.moneyFormat);
      priceElement.style.fontSize = '18px';
      priceElement.style.fontWeight = '600';
      priceElement.style.color = '#333';
      
      // Assemble price container
      priceContainer.appendChild(priceElement);
      
      // Add compare at price if available
      if (compareAtPrice) {
        const compareAtPriceElement = document.createElement('span');
        compareAtPriceElement.textContent = themeVendor.themeCurrency.formatMoney(parseFloat(compareAtPrice) * 100, theme.moneyFormat);
        compareAtPriceElement.style.fontSize = '14px';
        compareAtPriceElement.style.fontWeight = 'normal';
        compareAtPriceElement.style.color = '#999';
        compareAtPriceElement.style.textDecoration = 'line-through';
        compareAtPriceElement.style.marginLeft = '10px';
        priceContainer.appendChild(compareAtPriceElement);
      }
      
      // Create size selector (variant selector) - on one line with label
      const sizeContainer = document.createElement('div');
      sizeContainer.style.marginBottom = '15px';
      sizeContainer.style.marginTop = '15px';
      sizeContainer.style.display = 'flex';
      sizeContainer.style.alignItems = 'center';
      sizeContainer.style.justifyContent = 'center';
      sizeContainer.style.gap = '16px';
      
      // Create small label text for size
      const sizeLabel = document.createElement('label');
      /* GG MOD START - "Taglia scarpe" solo se i valori sono numeri di scarpa (es. 39-42), altrimenti "Taglia" */
      sizeLabel.textContent = hasShoeSizeValues(product) ? translations.shoeSize : translations.size;
      /* GG MOD END */
      sizeLabel.style.fontSize = '14px';
      sizeLabel.style.color = '#333';
      sizeLabel.style.margin = '0';
      sizeLabel.style.flexShrink = '0';
    
      // Create select with the specific styling
      const sizeSelect = document.createElement('select');
      sizeSelect.style.width = 'auto';
      sizeSelect.style.maxWidth = '90px';
      sizeSelect.style.padding = '8px 25px 8px 10px';
      sizeSelect.style.marginBottom = '0';
      sizeSelect.style.border = '1px solid #ddd';
      sizeSelect.style.borderRadius = '0'; // Flat corners
      sizeSelect.style.backgroundColor = 'white';
      sizeSelect.style.fontSize = '14px';
      sizeSelect.style.appearance = 'none'; // Remove default browser styling
      sizeSelect.style.backgroundImage = 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23333%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E")';
      sizeSelect.style.backgroundRepeat = 'no-repeat';
      sizeSelect.style.backgroundPosition = 'right 8px center';
      sizeSelect.style.backgroundSize = '12px';
      sizeSelect.setAttribute('data-product-handle', product.handle);
      
      // Find the color option in the product if it exists
      let colorOptionIndex = -1;
      let colorOptionValues = [];
      
      if (product.options) {
        colorOptionIndex = product.options.findIndex(option => 
          option.name.toLowerCase().includes('color') || 
          option.name.toLowerCase().includes('colour') ||
          option.name.toLowerCase() === 'colore' // Italian
        );
        
        if (colorOptionIndex !== -1) {
          colorOptionValues = product.options[colorOptionIndex].values;
        }
      }
      
      // Find the size option in the product
      let sizeOptionIndex = -1;
      
      if (product.options) {
        sizeOptionIndex = product.options.findIndex(option => 
          option.name.toLowerCase().includes('size') || 
          option.name.toLowerCase() === 'taglia' ||  // Italian for size
          option.name.toLowerCase() === 'misura'     // Alternative Italian word for size
        );
        
        // If no size option found, just use the first option (assuming it might be size)
        if (sizeOptionIndex === -1 && product.options.length > 0) {
          sizeOptionIndex = 0;
        }
      }
      
      // Determine which variant to select by default
      let defaultVariantId = '';
      let preferredColor = null;
      
      // Find an initial variant to select
      if (product.variants && product.variants.length > 0) {
        // If we have a preferred color, find a variant with that color
        if (preferredColor && colorOptionIndex !== -1) {
          const colorPosition = colorOptionIndex + 1;
          const matchingVariant = product.variants.find(variant => 
            variant[`option${colorPosition}`] === preferredColor && 
            variant.available !== false
          );
          
          if (matchingVariant) {
            defaultVariantId = matchingVariant.id;
          }
        }
        
        // If no preferred color or no matching variant found, use the first available variant
        if (!defaultVariantId) {
          const firstAvailable = product.variants.find(v => v.available !== false);
          if (firstAvailable) {
            defaultVariantId = firstAvailable.id;
          } else {
            // If no available variants, use the first one anyway
            defaultVariantId = product.variants[0].id;
          }
        }
      }
      
      // Add a default "Select Size" option
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = translations.selectSize;
      defaultOption.selected = !defaultVariantId;  // Only select if we don't have a default variant
      sizeSelect.appendChild(defaultOption);
      
      // Add size options to the dropdown
      if (product.variants && product.variants.length > 0) {
        // Get all unique size values
        const sizes = new Set();
        
        if (sizeOptionIndex !== -1) {
          const sizePosition = sizeOptionIndex + 1;
          
          // Group variants by size
          const sizeVariants = {};
          
          product.variants.forEach(variant => {
            const size = variant[`option${sizePosition}`];
            if (size) {
              if (!sizeVariants[size]) {
                sizeVariants[size] = [];
              }
              sizeVariants[size].push(variant);
            }
          });
          
          // For each size, find the appropriate variant
          Object.keys(sizeVariants).forEach(size => {
            // First try to find a variant with matching color
            let selectedVariant = null;
            
            if (preferredColor && colorOptionIndex !== -1) {
              const colorPosition = colorOptionIndex + 1;
              selectedVariant = sizeVariants[size].find(variant => 
                variant[`option${colorPosition}`] === preferredColor && 
                variant.available !== false
              );
            }
            
            // If no color match found, use the first available variant for this size
            if (!selectedVariant) {
              selectedVariant = sizeVariants[size].find(v => v.available !== false) || sizeVariants[size][0];
            }
            
            if (selectedVariant) {
              const option = document.createElement('option');
              option.value = selectedVariant.id;
              option.textContent = size;
              option.disabled = selectedVariant.available === false;
              
              if (selectedVariant.available === false) {
                option.textContent += ' (' + translations.outOfStock + ')';
              }
              
              // If this matches our default variant, select it
              if (selectedVariant.id.toString() === defaultVariantId.toString()) {
                option.selected = true;
              }
              
              sizeSelect.appendChild(option);
            }
          });
        } else {
          // If no size option found, just list all variants
          product.variants.forEach(variant => {
            const option = document.createElement('option');
            option.value = variant.id;
            
            // Create a display title based on available options
            let optionTitle = variant.title || 'Default';
            if (optionTitle.toLowerCase() === 'default title') {
              optionTitle = variant.option1 || 'One Size';
            }
            
            option.textContent = optionTitle;
            option.disabled = variant.available === false;
            
            if (variant.available === false) {
              option.textContent += ' (Out of Stock)';
            }
            
            // If this matches our default variant, select it
            if (variant.id.toString() === defaultVariantId.toString()) {
              option.selected = true;
            }
            
            sizeSelect.appendChild(option);
          });
        }
      }
      
      // Create add to cart button
      const addButton = document.createElement('button');
      addButton.textContent = translations.addToCart;
      addButton.style.width = '100%';
      addButton.style.padding = '12px 15px';
      addButton.style.backgroundColor = '#6b0000'; // Darker red/burgundy color
      addButton.style.color = 'white';
      addButton.style.border = 'none';
      addButton.style.borderRadius = '0'; // Remove border radius for flat look
      addButton.style.cursor = 'pointer';
      addButton.style.fontSize = '14px';
      addButton.style.fontWeight = '500';
      addButton.style.textTransform = 'uppercase';
      
      // Add the onclick handler with size validation
      addButton.onclick = function(event) {
        // Prevent default action
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        
        const selectedVariantId = sizeSelect.value;
        
        if (!selectedVariantId) {
          // Show error if no size selected
          sizeSelect.style.border = '1px solid red';
          
          // Create error message if it doesn't exist
          let errorMsg = sizeContainer.querySelector('.size-error-msg');
          if (!errorMsg) {
            errorMsg = document.createElement('div');
            errorMsg.className = 'size-error-msg';
            errorMsg.textContent = translations.pleaseSelectSize;
            errorMsg.style.color = 'red';
            errorMsg.style.fontSize = '12px';
            errorMsg.style.marginTop = '5px';
            sizeContainer.appendChild(errorMsg);
          }
          
          return;
        }
        
        // Clear any error styling
        sizeSelect.style.border = '1px solid #ddd';
        const errorMsg = sizeContainer.querySelector('.size-error-msg');
        if (errorMsg) {
          errorMsg.remove();
        }
        
        addToCart(selectedVariantId);
      };
      
      // Handle size select change - clear error styling when value changes
      sizeSelect.addEventListener('change', function() {
        if (sizeSelect.value) {
          sizeSelect.style.border = '1px solid #ddd';
          const errorMsg = sizeContainer.querySelector('.size-error-msg');
          if (errorMsg) {
            errorMsg.remove();
          }
        }
      });
      
      // Assemble size container
      sizeContainer.appendChild(sizeLabel);
      sizeContainer.appendChild(sizeSelect);
      
      // Assemble product element
      imageContainer.appendChild(image);
      productElement.appendChild(imageContainer);
      productElement.appendChild(titleLink);
      
      // Don't show product type if it's "PRODUCT"
      if (productType.style.display !== 'none') {
        productElement.appendChild(productType);
      }
      
      productElement.appendChild(priceContainer);
      productElement.appendChild(sizeContainer);
      productElement.appendChild(addButton);
      
      return productElement;
    }
    
    // Add this function globally so the onclick handlers can access it
    /* GG MOD START - upsell a slot configurabili: pulsante esplicito, sostituzione per slot, esaurito */
    window.addToCart = async function(variantId, triggerButton) {
      if (!variantId) {
        console.error('No variant ID provided');
        return;
      }
    
      // Add translations retrieval here
      const translations = window.themeTranslations?.relatedProducts || {
        adding: "Adding...",
        added: "Added!",
        outOfStock: "Out of Stock"
      };
      
      const button = triggerButton || event.target;
      const originalText = button.innerHTML;
      button.innerHTML = translations.adding; 
      button.disabled = true;
      
      try {
        // Add to cart using fetch
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_upsell_source': 'popup'
            }
          })
        });
        
        if (response.ok) {
          button.innerHTML = translations.added;

          // Get the product card element (parent of the button) - handle both desktop and mobile
          const productCard = button.closest('.popup-product-card') || button.closest('.mobile-upsell-product');

          if (window.gtag && productCard) {
            gtag('event', 'add_to_cart', {
              currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
              value: parseFloat(productCard.getAttribute('data-product-price') || '0'),
              item_list_id: 'cart_upsell',
              item_list_name: 'Cart Upsell',
              items: [{
                item_id: productCard.getAttribute('data-product-id') || '',
                item_name: productCard.getAttribute('data-product-title') || '',
                item_variant: String(variantId),
                item_list_id: 'cart_upsell',
                item_list_name: 'Cart Upsell',
                index: parseInt(productCard.getAttribute('data-slot-position') || '0', 10),
                quantity: 1,
                price: parseFloat(productCard.getAttribute('data-product-price') || '0')
              }]
            });
          }

          // Get the full cart data
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          if (productCard) {
            replaceUpsellCardAfterAdd(productCard, cart, button, originalText);
          }

          // Aggiorna CartItems.cart e segna come stale
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));

          // Triggera loadHTML() → loadForm() → updateTotal() per aggiornare drawer e totale
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
        } else if (response.status === 422) {
          // Variante esaurita nel frattempo: lo stock reale è quello di /cart/add.js
          button.innerHTML = translations.outOfStock;
          setTimeout(function() {
            button.innerHTML = originalText;
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.innerHTML = 'Error';
        
        setTimeout(function() {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 2000);
      }
    };

    /*
     * Dopo un'aggiunta: la scheda intimo resta (si può aggiungere un altro colore/taglia);
     * le altre schede vengono sostituite dal candidato successivo dello stesso slot,
     * escludendo quanto è ora nel carrello e quanto mostrano le altre schede.
     */
    function replaceUpsellCardAfterAdd(productCard, cart, button, originalText) {
      if (productCard.getAttribute('data-upsell-kind') === 'underwear') {
        setTimeout(function() {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 1500);
        return;
      }

      const slotKey = productCard.getAttribute('data-slot-key');
      const slot = getCartUpsellData().slots.find(item => item.key === slotKey);
      if (!slot) return;

      const excludedIds = new Set();
      Array.from(productCard.parentNode ? productCard.parentNode.children : []).forEach(card => {
        if (card === productCard) return;
        (card.getAttribute('data-model-ids') || card.getAttribute('data-product-id') || '')
          .split(',')
          .filter(Boolean)
          .forEach(id => excludedIds.add(id));
      });

      const replacementProduct = resolveCartUpsellSlot(slot, {
        cartProductIds: new Set((cart.items || []).map(item => String(item.product_id))),
        excludedIds: excludedIds,
        isWomen: window.showingWomensProducts === true
      });

      if (!replacementProduct) {
        productCard.remove();
        return;
      }

      const slotIndex = parseInt(productCard.getAttribute('data-slot-position') || '0', 10);
      const newProductElement = productCard.classList.contains('mobile-upsell-product')
        ? createMobileProductCard(replacementProduct, slotIndex)
        : createProductCard(replacementProduct, slotIndex);
      productCard.parentNode.replaceChild(newProductElement, productCard);
    }

    function getUpsellOptionIndex(product, matcher) {
      return (product.options || []).findIndex(option => matcher(String(option.name || '').toLowerCase()));
    }

    // I nomi delle opzioni possono essere tradotti: si riconoscono le lingue del sito
    function isUpsellColorOption(name) {
      return /colo|farbe|couleur|kleur|kolor|cor$|χρώμα/.test(name);
    }

    function isUpsellSizeOption(name) {
      return /size|tagli|misura|grö|taille|talla|tamanho|maat|rozmiar|μέγεθος/.test(name);
    }

    function hasShoeSizeValues(product) {
      const sizeIndex = getUpsellOptionIndex(product, isUpsellSizeOption);
      const values = sizeIndex !== -1 ? product.options[sizeIndex].values || [] : [];
      return values.some(value => /^\d{2}\s*[-–\/]\s*\d{2}$/.test(String(value).trim()));
    }

    /*
     * Scheda intimo: un solo slot che aggrega più prodotti (modelli) con le stesse opzioni.
     * Modello, colore e taglia aggiornano nome, immagine, prezzo e disponibilità;
     * l'aggiunta usa l'id della variante del prodotto originale, quindi il suo stock.
     */
    function createUnderwearUpsellCard(product, slotIndex = 0, isMobile = false) {
      const translations = window.themeTranslations?.relatedProducts || {
        giftIdea: "Gift Idea",
        addToCart: "Add to Cart",
        outOfStock: "Out of Stock"
      };
      const models = product.models || [];
      const state = { modelIndex: 0, variant: null };

      const card = document.createElement('div');
      card.className = (isMobile ? 'mobile-upsell-product' : 'popup-product-card') +
        ' nobile-upsell-uw' + (isMobile ? ' nobile-upsell-uw--mobile' : '');
      card.setAttribute('data-upsell-kind', 'underwear');
      card.setAttribute('data-slot-position', slotIndex);
      if (product.slotKey) card.setAttribute('data-slot-key', product.slotKey);
      card.setAttribute('data-model-ids', models.map(model => model.product.id).join(','));

      const media = document.createElement('a');
      media.className = 'nobile-upsell-uw__media';
      const image = document.createElement('img');
      image.loading = 'lazy';
      media.appendChild(image);

      if (product.isGiftIdea && !isMobile) {
        const ribbon = document.createElement('div');
        ribbon.className = 'nobile-upsell-uw__ribbon';
        ribbon.textContent = product.giftLabel || translations.giftIdea;
        media.appendChild(ribbon);
      }

      const head = document.createElement('div');
      head.className = 'nobile-upsell-uw__head';
      // Stesso markup delle altre schede (h3 dentro il link), così eredita il font dei titoli
      const titleLink = document.createElement('a');
      titleLink.className = 'nobile-upsell-uw__title';
      const title = document.createElement(isMobile ? 'span' : 'h3');
      titleLink.appendChild(title);
      head.appendChild(titleLink);
      if (product.isGiftIdea && isMobile) {
        const badge = document.createElement('span');
        badge.className = 'nobile-upsell-uw__badge';
        badge.textContent = product.giftLabel || translations.giftIdea;
        head.appendChild(badge);
      }
      const price = document.createElement('div');
      price.className = 'nobile-upsell-uw__price';
      head.appendChild(price);

      // Modelli come pulsanti visibili; il menu a tendina subentra via CSS quando la scheda è stretta
      const modelGroup = document.createElement('div');
      modelGroup.className = 'nobile-upsell-uw__models';
      modelGroup.setAttribute('role', 'group');
      const modelSelect = document.createElement('select');
      modelSelect.className = 'nobile-upsell-uw__model-select';

      models.forEach((model, index) => {
        const modelButton = document.createElement('button');
        modelButton.type = 'button';
        modelButton.className = 'nobile-upsell-uw__model';
        modelButton.textContent = model.label;
        modelButton.addEventListener('click', () => selectModel(index));
        modelGroup.appendChild(modelButton);

        const option = document.createElement('option');
        option.value = index;
        option.textContent = model.label;
        modelSelect.appendChild(option);
      });
      modelSelect.addEventListener('change', () => selectModel(parseInt(modelSelect.value, 10)));
      if (models.length < 2) {
        modelGroup.hidden = true;
        modelSelect.hidden = true;
      }

      const controls = document.createElement('div');
      controls.className = 'nobile-upsell-uw__controls';
      const colorSelect = document.createElement('select');
      const sizeSelect = document.createElement('select');
      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'nobile-upsell-uw__add';
      addButton.textContent = translations.addToCart;
      controls.appendChild(colorSelect);
      controls.appendChild(sizeSelect);
      controls.appendChild(addButton);

      card.appendChild(media);
      card.appendChild(head);
      card.appendChild(modelGroup);
      card.appendChild(modelSelect);
      card.appendChild(controls);

      function currentModel() {
        return models[state.modelIndex];
      }

      function optionValue(variant, index) {
        return index === -1 ? null : variant[`option${index + 1}`];
      }

      function findVariant(modelProduct, color, size) {
        const colorIndex = getUpsellOptionIndex(modelProduct, isUpsellColorOption);
        const sizeIndex = getUpsellOptionIndex(modelProduct, isUpsellSizeOption);
        return modelProduct.variants.find(variant =>
          (colorIndex === -1 || optionValue(variant, colorIndex) === color) &&
          (sizeIndex === -1 || optionValue(variant, sizeIndex) === size)
        ) || null;
      }

      // Variante più vicina alla selezione corrente: stesso colore e taglia, poi stesso colore, poi la prima disponibile
      function pickVariant(modelProduct, color, size) {
        const colorIndex = getUpsellOptionIndex(modelProduct, isUpsellColorOption);
        const exact = findVariant(modelProduct, color, size);
        if (exact && exact.available) return exact;

        const sameColor = colorIndex === -1 ? null : modelProduct.variants.find(variant =>
          variant.available && optionValue(variant, colorIndex) === color
        );
        return sameColor || modelProduct.variants.find(variant => variant.available) || modelProduct.variants[0];
      }

      function fillSelect(select, values, selectedValue, isAvailable) {
        select.innerHTML = '';
        values.forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = isAvailable(value) ? value : `${value} - ${translations.outOfStock}`;
          option.disabled = !isAvailable(value);
          option.selected = value === selectedValue;
          select.appendChild(option);
        });
      }

      function render() {
        const modelProduct = currentModel().product;
        const variant = state.variant;
        const colorIndex = getUpsellOptionIndex(modelProduct, isUpsellColorOption);
        const sizeIndex = getUpsellOptionIndex(modelProduct, isUpsellSizeOption);
        const color = optionValue(variant, colorIndex);
        const size = optionValue(variant, sizeIndex);
        const url = (modelProduct.url || `/products/${modelProduct.handle}`) + `?variant=${variant.id}`;

        Array.from(modelGroup.children).forEach((modelButton, index) => {
          modelButton.setAttribute('aria-pressed', index === state.modelIndex ? 'true' : 'false');
        });
        modelSelect.value = String(state.modelIndex);

        colorSelect.hidden = colorIndex === -1;
        if (colorIndex !== -1) {
          colorSelect.setAttribute('aria-label', modelProduct.options[colorIndex].name);
          fillSelect(colorSelect, modelProduct.options[colorIndex].values, color, value =>
            modelProduct.variants.some(item => item.available && optionValue(item, colorIndex) === value)
          );
        }

        sizeSelect.hidden = sizeIndex === -1;
        if (sizeIndex !== -1) {
          sizeSelect.setAttribute('aria-label', modelProduct.options[sizeIndex].name);
          fillSelect(sizeSelect, modelProduct.options[sizeIndex].values, size, value => {
            const candidate = findVariant(modelProduct, color, value);
            return Boolean(candidate && candidate.available);
          });
        }

        title.textContent = modelProduct.title;
        titleLink.href = url;
        media.href = url;
        image.src = variant.image || (modelProduct.images[0] ? modelProduct.images[0].src : '');
        image.alt = `${modelProduct.title}${variant.title ? ' - ' + variant.title : ''}`;

        const priceValue = parseFloat(variant.price);
        const compareValue = parseFloat(variant.compare_at_price);
        price.innerHTML = '';
        const priceElement = document.createElement('span');
        priceElement.textContent = themeVendor.themeCurrency.formatMoney(priceValue * 100, theme.moneyFormat);
        price.appendChild(priceElement);
        if (compareValue > priceValue) {
          const compareElement = document.createElement('s');
          compareElement.textContent = themeVendor.themeCurrency.formatMoney(compareValue * 100, theme.moneyFormat);
          price.appendChild(compareElement);
        }

        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? translations.addToCart : translations.outOfStock;

        // Attributi letti dal tracciamento GA4 e da window.addToCart
        card.setAttribute('data-product-handle', modelProduct.handle);
        card.setAttribute('data-product-id', modelProduct.id);
        card.setAttribute('data-product-title', modelProduct.title || '');
        card.setAttribute('data-product-price', variant.price);
      }

      function selectModel(index) {
        const previous = state.variant;
        const previousProduct = currentModel().product;
        state.modelIndex = index;
        const modelProduct = currentModel().product;
        const color = optionValue(previous, getUpsellOptionIndex(previousProduct, isUpsellColorOption));
        const size = optionValue(previous, getUpsellOptionIndex(previousProduct, isUpsellSizeOption));
        state.variant = pickVariant(modelProduct, color, size);
        render();
      }

      colorSelect.addEventListener('change', () => {
        const modelProduct = currentModel().product;
        const size = optionValue(state.variant, getUpsellOptionIndex(modelProduct, isUpsellSizeOption));
        state.variant = pickVariant(modelProduct, colorSelect.value, size);
        render();
      });

      sizeSelect.addEventListener('change', () => {
        const modelProduct = currentModel().product;
        const color = optionValue(state.variant, getUpsellOptionIndex(modelProduct, isUpsellColorOption));
        state.variant = findVariant(modelProduct, color, sizeSelect.value) || state.variant;
        render();
      });

      addButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (state.variant && state.variant.available) {
          window.addToCart(state.variant.id, addButton);
        }
      });

      // Opzione iniziale: primo modello configurato, prima variante disponibile
      state.variant = pickVariant(currentModel().product, null, null);
      render();

      return card;
    }
    /* GG MOD END */
    
      // Add this to your existing script within the IIFE
      function initMobileCartUpselling() {
        // Listen for cart changes to insert the upsell section
        document.addEventListener('theme:cart:change', function(event) {
          if (window.innerWidth <= 768) { // Only for mobile devices
            setTimeout(insertMobileUpsellSection, 1200);
          }
        });
        
        // Listen for cart drawer opening
        document.addEventListener('theme:cart:open', function() {
          if (window.innerWidth <= 768) { // Only for mobile devices
            setTimeout(insertMobileUpsellSection, 1200);
          }
        });
        
        // Also listen for scroll:lock which Pipeline theme uses when opening drawers
        document.addEventListener('theme:scroll:lock', function() {
          if (window.innerWidth <= 768) {
            setTimeout(insertMobileUpsellSection, 1200);
          }
        });
      }
    
      function insertMobileUpsellSection() {
        //console.log('Attempting to insert mobile upsell section');
  
        const translations = window.themeTranslations?.relatedProducts || {
          title: "COMPLETE YOUR LOOK",
          subtitle: "Find out how to take care of it and add some accessories."
        };
        
        // Check if mobile upsell already exists
        if (document.getElementById('mobile-cart-upsell')) {
          //console.log('Mobile upsell already exists');
          return;
        }
        
        // Find the cart items container - we'll insert AFTER this
        const cartItems = document.querySelector('.cart__items');
        //console.log('Cart items found:', !!cartItems);
        
        if (!cartItems) {
          //console.log('Could not find cart items container');
          return;
        }
        
        // Create the mobile upsell container
        const upsellSection = document.createElement('div');
        upsellSection.id = 'mobile-cart-upsell';
        upsellSection.style.margin = '0';
        upsellSection.style.borderTop = '1px solid #e6e6e6';
        upsellSection.style.padding = '15px 0';
        
        // Create the "Complete Your Look" heading (not a button anymore)
        const completeHeading = document.createElement('div');
        completeHeading.textContent = translations.title;
        completeHeading.style.width = '100%';
        completeHeading.style.padding = '10px 15px';
        completeHeading.style.backgroundColor = '#f9f9f9';
        completeHeading.style.color = '#333';
        completeHeading.style.fontWeight = '600';
        completeHeading.style.fontSize = '14px';
        completeHeading.style.display = 'flex';
        completeHeading.style.justifyContent = 'center'; // Changed from 'space-between' to 'center'
        completeHeading.style.alignItems = 'center';
        completeHeading.style.textAlign = 'center';
        
        // Create products container (visible by default)
        const productsContainer = document.createElement('div');
        productsContainer.id = 'mobile-upsell-products';
        productsContainer.style.display = 'block'; // Show by default
        productsContainer.style.padding = '10px 15px';
        productsContainer.setAttribute('data-loaded', 'false'); // Track if products are loaded
        
        // Add loading indicator initially
        productsContainer.innerHTML = '<div style="text-align: center; padding: 10px; font-size: 12px;">Loading recommendations...</div>';
        
        // Add to the DOM
        upsellSection.appendChild(completeHeading);
        upsellSection.appendChild(productsContainer);
        
        // Insert after the cart items
        cartItems.parentNode.insertBefore(upsellSection, cartItems.nextSibling);
        //console.log('Inserted upsell section after cart items');
        
        // Load products immediately
        populateMobileUpsellProducts();
        
        // Also preload in background (can help with refreshing)
        preloadMobileUpsellProducts();
      }
      
      // New function to preload products
      function preloadMobileUpsellProducts() {
        // Add a static property to track last preload time
        if (!preloadMobileUpsellProducts.lastPreloadTime) {
          preloadMobileUpsellProducts.lastPreloadTime = 0;
        }
      
        const currentTime = Date.now();
        const PRELOAD_INTERVAL = 5 * 60 * 1000; // 5 minutes minimum between preloads
      
        // Check if enough time has passed since last preload
        if (currentTime - preloadMobileUpsellProducts.lastPreloadTime < PRELOAD_INTERVAL) {
          //console.log('Skipping preload - too soon since last attempt');
          return;
        }
      
        // Mark the current time as last preload time
        preloadMobileUpsellProducts.lastPreloadTime = currentTime;
      
        //console.log('Initiating preload of mobile upsell products');
        
        getRelatedProductsCart(true)
          .then(cart => {
            // Only preload if cart has items
            if (cart.item_count > 0) {
              return fetchCustomProducts(cart);
            }
            throw new Error('Empty cart');
          })
          .then(data => {
            // Store the products in a global variable for quick access
            window.preloadedUpsellProducts = data.products;
            //console.log('Preloaded upsell products:', data.products.length);
            
            // Mark as preloaded
            const container = document.getElementById('mobile-upsell-products');
            if (container) {
              container.setAttribute('data-preloaded', 'true');
            }
          })
          .catch(error => {
            console.error('Error preloading upsell products:', error);
          });
      }
      
      // Update the populate function to use preloaded products when available
      async function populateMobileUpsellProducts() {
        //console.log('Populating mobile upsell products');
        
        const container = document.getElementById('mobile-upsell-products');
        if (!container) {
          console.error('Mobile upsell products container not found');
          return;
        }
      
        try {
          // Use the latest cart from theme events, with /cart.js only as fallback
          const cart = await getRelatedProductsCart(true);
          
          if (!cart.items || cart.items.length === 0) {
            container.innerHTML = '<div style="text-align: center; padding: 10px; font-size: 12px;">No items in cart</div>';
            return;
          }
      
          // Shopify returns cart.items in reverse chronological order: index 0 is the most recently added item.
          // Using the last array item here intentionally selects the first product added to the cart.
          const firstItem = cart.items[cart.items.length - 1];
          //console.log('First item in cart:', firstItem);
      
          // Check if this item is in the men's or women's collection
          let isMensProduct = checkIfProductInCollection(firstItem.handle, 'klaviyo-uomo', firstItem.product_id);
          const isWomensProduct = checkIfProductInCollection(firstItem.handle, 'klaviyo-donna', firstItem.product_id);
          
          //console.log('Is men\'s product?', isMensProduct, 'Is women\'s product?', isWomensProduct);
          
          // If it's neither a men's nor women's product, treat as men's product
          if (!isMensProduct && !isWomensProduct) {
            //console.log('Product is neither men\'s nor women\'s, treating as men\'s product');
            isMensProduct = true;
          }
          
          // Set a flag to track which type of products to show
          window.showingWomensProducts = isWomensProduct;
      
          // Fetch custom products with detected context
          const productsData = await fetchCustomProducts(cart);
      
          // Clear container
          container.innerHTML = '';
          
          if (!productsData.products || productsData.products.length === 0) {
            container.innerHTML = '<div style="text-align: center; padding: 10px; font-size: 12px;">No recommendations available</div>';
            return;
          }
          
          // Get just 2 products for mobile
          const mobileProducts = productsData.products.slice(0, 3);
          
          // Create and append each product card
          mobileProducts.forEach((product, index) => {
            const card = createMobileProductCard(product, index);
            container.appendChild(card);
          });
          fireUpsellViewItemList(mobileProducts);

          // Mark as loaded
          container.setAttribute('data-loaded', 'true');
      
        } catch (error) {
          console.error('Error in mobile upsell product flow:', error);
          container.innerHTML = '<div style="text-align: center; padding: 10px; color: red; font-size: 12px;">Error loading recommendations</div>';
        }
      }
    
    function createMobileProductCard(product, slotIndex = 0) {
      /* GG MOD START - upsell a slot configurabili: scheda intimo dedicata */
      if (product.kind === 'underwear') {
        return createUnderwearUpsellCard(product, slotIndex, true);
      }
      /* GG MOD END */
      // Get translations
      const translations = window.themeTranslations?.relatedProducts || {
        selectSize: "Select Size",
        addToCart: "ADD TO CART"
      };

      // Create card container - style it like a cart item
      const card = document.createElement('div');
      card.className = 'mobile-upsell-product';
      card.style.padding = '10px 0';
      card.style.borderBottom = '1px solid #e6e6e6';
      card.style.display = 'flex';
      card.style.alignItems = 'center';
      card.setAttribute('data-product-handle', product.handle);
      card.setAttribute('data-slot-position', slotIndex);
      card.setAttribute('data-product-id', product.id);
      card.setAttribute('data-product-title', product.title || '');
      card.setAttribute('data-product-price',
        product.variants && product.variants[0] ? product.variants[0].price : 0);
      /* GG MOD START - upsell a slot configurabili: slot di provenienza della scheda */
      if (product.slotKey) card.setAttribute('data-slot-key', product.slotKey);
      /* GG MOD END */
      
      // Get product image
      const imageSrc = product.images && product.images.length > 0 
        ? product.images[0].src 
        : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-image.png';
      
      // Create image container (left)
      const imageContainer = document.createElement('div');
      imageContainer.style.width = '70px';
      imageContainer.style.height = '70px';
      imageContainer.style.marginRight = '15px';
      imageContainer.style.flexShrink = '0';
      
      const image = document.createElement('img');
      image.src = imageSrc;
      image.alt = product.title || 'Product';
      image.style.width = '100%';
      image.style.height = '100%';
      image.style.objectFit = 'cover';
      
      imageContainer.appendChild(image);
      
      // Create product details (middle)
      const detailsContainer = document.createElement('div');
      detailsContainer.style.flex = '1';
      detailsContainer.style.minWidth = '0';
      
  
  
      // Create container for title and gift label
      const titleContainer = document.createElement('div');
      titleContainer.style.display = 'flex';
      titleContainer.style.alignItems = 'center';
      titleContainer.style.marginBottom = '5px';
      titleContainer.style.flexWrap = 'wrap';
      
      // Product title
      const title = document.createElement('div');
      title.textContent = product.title;
      title.style.fontSize = '14px';
      title.style.fontWeight = '500';
      title.style.marginRight = '6px';
      
      // Add title to the container
      titleContainer.appendChild(title);
      
      // If the product is a gift idea, add a gift label next to the title
      if (product.isGiftIdea) {
        const giftLabel = document.createElement('div');
        giftLabel.style.backgroundColor = '#e36f1a'; // Orange color
        giftLabel.style.color = 'white';
        giftLabel.style.fontSize = '10px';
        giftLabel.style.fontWeight = 'bold';
        giftLabel.style.padding = '2px 5px';
        giftLabel.style.display = 'inline-block';
        giftLabel.style.borderRadius = '2px';
        
        // Get the gift idea text from translations
        /* GG MOD START - testo badge configurabile dall'editor */
        giftLabel.textContent = product.giftLabel || translations.giftIdea || 'Gift Idea';
        /* GG MOD END */
        
        // Add the gift label to the title container
        titleContainer.appendChild(giftLabel);
      }
      // Price
      const price = document.createElement('div');
      let priceValue = '—';
      if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        if (firstVariant.price) {
          priceValue = themeVendor.themeCurrency.formatMoney(parseFloat(firstVariant.price) * 100, theme.moneyFormat);
        }
      }
      price.innerHTML = priceValue;
      price.style.fontSize = '14px';
      price.style.fontWeight = '500';
      price.style.marginBottom = '5px';
      
      // Create right column for controls
      const controlsContainer = document.createElement('div');
      controlsContainer.style.flexShrink = '0';
      controlsContainer.style.width = '120px';
      controlsContainer.style.marginLeft = '10px';
      
      // Size selector with dropdown styling
      const sizeSelector = document.createElement('select');
      sizeSelector.style.width = '100%';
      sizeSelector.style.padding = '6px 20px 6px 8px';
      sizeSelector.style.border = '1px solid #e6e6e6';
      sizeSelector.style.borderRadius = '0';
      sizeSelector.style.fontSize = '12px';
      sizeSelector.style.marginBottom = '8px';
      sizeSelector.style.appearance = 'none';
      sizeSelector.style.backgroundImage = 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23333%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E")';
      sizeSelector.style.backgroundRepeat = 'no-repeat';
      sizeSelector.style.backgroundPosition = 'right 5px center';
      sizeSelector.style.backgroundSize = '10px';
      sizeSelector.style.textAlign = 'center';
      
      // Find the size option in the product
      let sizeOptionIndex = -1;
          
      if (product.options) {
        sizeOptionIndex = product.options.findIndex(option => 
          option.name.toLowerCase().includes('size') || 
          option.name.toLowerCase() === 'taglia' ||
          option.name.toLowerCase() === 'misura'
        );
            
        if (sizeOptionIndex === -1 && product.options.length > 0) {
          sizeOptionIndex = 0; // Default to first option
        }
      }
      
      // Determine which variant to select by default
      let defaultVariantId = '';
      
      // If we have variants, find the first available one
      if (product.variants && product.variants.length > 0) {
        const firstAvailable = product.variants.find(v => v.available !== false);
        if (firstAvailable) {
          defaultVariantId = firstAvailable.id;
        } else {
          // If no available variants, use the first one anyway
          defaultVariantId = product.variants[0].id;
        }
      }
      
      // Add default "Select Size" option
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = translations.selectSize;
      defaultOption.selected = !defaultVariantId; // Only select if we don't have a default variant
      sizeSelector.appendChild(defaultOption);
          
      // Add variants to the dropdown
      if (product.variants && product.variants.length > 0) {
        const sizePosition = sizeOptionIndex + 1;
        const variants = {};
            
        // Group variants by size option
        product.variants.forEach(variant => {
          const size = variant[`option${sizePosition}`] || 'One Size';
          /* GG MOD START - upsell mobile: per ogni taglia preferisce una variante disponibile */
          if (!variants[size] || (!variants[size].available && variant.available)) {
            variants[size] = variant;
          }
          /* GG MOD END */
        });

        // Add each unique size as an option
        Object.keys(variants).forEach(size => {
          const variant = variants[size];
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = size;
          /* GG MOD START - upsell mobile: taglie esaurite non selezionabili, come su desktop */
          if (variant.available === false) {
            option.disabled = true;
            option.textContent += ' (' + (translations.outOfStock || 'Out of Stock') + ')';
          }
          /* GG MOD END */
          
          // If this matches our default variant, select it
          if (variant.id.toString() === defaultVariantId.toString()) {
            option.selected = true;
          }
          
          sizeSelector.appendChild(option);
        });
      }
      
      // Add to cart button
      const addButton = document.createElement('button');
      addButton.textContent = translations.addToCart;
      addButton.style.width = '100%';
      addButton.style.padding = '7px';
      addButton.style.backgroundColor = '#233658';
      addButton.style.color = 'white';
      addButton.style.border = 'none';
      addButton.style.fontSize = '12px';
      addButton.style.fontWeight = '500';
      addButton.style.cursor = 'pointer';
      addButton.style.textAlign = 'center';
      
      // Add to cart functionality
      addButton.addEventListener('click', function() {
        const variantId = sizeSelector.value;
        
        if (!variantId) {
          // No size selected, show error styling
          sizeSelector.style.border = '1px solid red';
          return;
        }
        
        // Use the existing addToCart function
        window.addToCart(variantId);
      });
      
      // Change event for size selector
      sizeSelector.addEventListener('change', function() {
        if (sizeSelector.value) {
          sizeSelector.style.border = '1px solid #e6e6e6';
        }
      });
      
      // Assemble the product card
      detailsContainer.appendChild(titleContainer);
      detailsContainer.appendChild(price);
      
      controlsContainer.appendChild(sizeSelector);
      controlsContainer.appendChild(addButton);
      
      card.appendChild(imageContainer);
      card.appendChild(detailsContainer);
      card.appendChild(controlsContainer);
      
      return card;
    }
    
    // Initialize mobile upselling when DOM is loaded
    document.addEventListener('DOMContentLoaded', function() {
      initMobileCartUpselling();
    });

    /* GG MOD START - NobileAutoGift: omaggio automatico in carrello */

    /* Durata della cache degli id prodotto delle collection trigger.
       Sta in localStorage per sopravvivere alla chiusura della scheda: le collection
       cambiano di rado, il TTL copre il caso in cui cambino. */
    const AUTOGIFT_COLLECTION_TTL = 30 * 60 * 1000;

    /* Per quanto una lettura di /cart.js resta riusabile dalle altre regole. */
    const AUTOGIFT_CART_FRESH_MS = 1500;

    /* GG MOD START - diagnostica NobileAutoGift: esito dell'ultima valutazione di ogni regola
       in un attributo del carrello, che Shopify riporta sull'ordine. Sull'ordine senza
       omaggio si legge dall'admin perché non è scattato. Formato:
         v<versione> <pagina> <gg/mm hh:mm:ss> | <id blocco> <esito>[+skip] <trigger>/<soglia> [h:pending|h:partial] @<hh:mm:ss> | …
       Il prefisso "_" lo marca come interno, da non mostrare al cliente. La deduplica delle
       scritture sta in sessionStorage. */
    const AUTOGIFT_DIAG_ATTRIBUTE = '_autoGift';
    const AUTOGIFT_DIAG_VERSION = '2026-09-25';
    const AUTOGIFT_DIAG_DEBOUNCE_MS = 400;
    const AUTOGIFT_DIAG_WRITTEN_KEY = 'nobileGiftDiagWritten';

    const autoGiftDiag = {
      rules: {},
      cart: null,
      timer: null,

      _ruleId(instance) {
        const id = String(instance.config.ruleId || instance.config.giftProductId);
        return id.split('_').pop();
      },

      _time(ts, withDate) {
        const d = new Date(ts);
        const pad = n => String(n).padStart(2, '0');
        const time = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        return withDate ? `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${time}` : time;
      },

      /* Conteggio trigger rispetto alla soglia: confrontato con le righe dell'ordine dice
         se la valutazione era aggiornata al momento del checkout. */
      _progress(instance, cart) {
        const cfg = instance.config;
        if (cfg.minQty !== null && cfg.minQty !== undefined) {
          // Stesso conteggio di _getConditionStatus, che però esce prima su alcune reason
          const ids = cfg.triggerProductIds || [];
          const quantities = (cart.items || [])
            .filter(item => ids.includes(item.product_id))
            .map(item => item.quantity);
          const qty = cfg.triggerMode === 'products'
            ? Math.max(0, ...quantities)
            : quantities.reduce((sum, q) => sum + q, 0);
          return `${qty}/${cfg.minQty}`;
        }
        if (cfg.minAmount > 0) return `${Math.round(cart.total_price / 100)}/${Math.round(cfg.minAmount / 100)}`;
        return '';
      },

      /* outcome null = evento senza nuova valutazione (sync scartato): resta l'esito
         precedente, aggiornando solo il flag +skip. Il flag si accende solo se il carrello
         scartato non è riconciliato: lo scarto dell'evento che la regola stessa rilancia
         dopo una propria scrittura è fisiologico e non va segnalato. */
      record(instance, outcome, cart) {
        try {
          const id = this._ruleId(instance);
          const prev = this.rules[id] || {};
          const base = outcome || prev.base || 'pending';
          this.rules[id] = {
            base,
            skip: !!(instance._skippedCart && !instance._isReconciled(instance._skippedCart)),
            progress: cart ? this._progress(instance, cart) : (prev.progress || ''),
            hydration: instance._hydration,
            at: base === prev.base ? prev.at : Date.now()
          };
          if (cart && cart.items) this.cart = cart;
          this.schedule();
        } catch (e) {
          console.error('[NobileAutoGift] diag record error:', e);
        }
      },

      schedule() {
        if (!AUTOGIFT_ATTRIBUTES_ENABLED) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.flush(), AUTOGIFT_DIAG_DEBOUNCE_MS);
      },

      /* Si scrive solo a carrello fermo: una update.js in mezzo alle scritture delle regole
         aggiungerebbe una richiesta concorrente e fotograferebbe uno stato di passaggio. */
      _busy() {
        const instances = window._nobileAutoGiftInstances || [];
        return instances.some(inst => inst._processing)
          || Object.keys(window._nobileAutoGiftAddLocks || {}).length > 0
          || Object.keys(window._nobileAutoGiftRemovalLocks || {}).length > 0;
      },

      _body() {
        return Object.keys(this.rules).sort().map(id => {
          const r = this.rules[id];
          return [
            id,
            r.base + (r.skip ? '+skip' : ''),
            r.progress,
            r.hydration && r.hydration !== 'ok' ? `h:${r.hydration}` : '',
            `@${this._time(r.at)}`
          ].filter(Boolean).join(' ');
        }).join(' | ');
      },

      async flush() {
        this.timer = null;
        if (this._busy()) { this.schedule(); return; }

        const cart = this.cart;
        // Da un carrello vuoto non nasce un ordine: la prima valutazione con righe scriverà
        if (!cart || !cart.item_count) return;

        const body = this._body();
        const signature = `${cart.token || ''}#${body}`;
        let lastWritten = null;
        try { lastWritten = sessionStorage.getItem(AUTOGIFT_DIAG_WRITTEN_KEY); } catch (e) {}
        if (signature === lastWritten) return;

        const value = `v${AUTOGIFT_DIAG_VERSION} ${window.location.pathname} ${this._time(Date.now(), true)} | ${body}`;
        const cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

        try {
          // keepalive: la scrittura sopravvive alla navigazione, tipicamente il click sul checkout
          const response = await fetch(`${cartRoute}/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { [AUTOGIFT_DIAG_ATTRIBUTE]: value } }),
            keepalive: true
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          try { sessionStorage.setItem(AUTOGIFT_DIAG_WRITTEN_KEY, signature); } catch (e) {}
          agLog('diag: attributo carrello aggiornato', value);
        } catch (e) {
          console.error('[NobileAutoGift] diag write error:', e);
        }
      }
    };

    window.nobileAutoGiftDiag = function() {
      console.log(`[NobileAutoGift] diag — ${autoGiftDiag._body()}`, autoGiftDiag.rules);
    };
    /* GG MOD END */

    window.nobileAutoGiftClearCache = function() {
      let n = 0;
      try {
        Object.keys(localStorage)
          .filter(k => k.indexOf('nobileGiftColl_') === 0)
          .forEach(k => { localStorage.removeItem(k); n++; });
      } catch (e) {}
      console.log(`[NobileAutoGift] cache collection svuotata (${n} voci)`);
    };

    class NobileAutoGift {

      constructor(config) {
        this.config = config;
        this._processing = false;
        this._giftUnavailable = false;
        this._giftWasPresent = false;
        this._pendingCouponCode = null;
        /* GG MOD START - stato per la diagnostica (autoGiftDiag) */
        this._skippedCart = null;
        this._lastAddOutcome = null;
        this._hydration = (config.triggerCollectionHandles || []).filter(Boolean).length ? 'pending' : 'ok';
        /* GG MOD END */
        this.cartRoute =(window.theme && window.theme.routes && window.theme.routes.cart)
          ? window.theme.routes.cart : '/cart';
        this.sync = this.sync.bind(this);
      }

      _getConditionStatus(cart, pendingCouponCode = null) {
        const cfg = this.config;
        const items = cart.items || [];
        const status = {
          ok: true,
          reason: 'ok',
          giftProductId: cfg.giftProductId,
          triggerMode: cfg.triggerMode,
          triggerProductIdsCount: (cfg.triggerProductIds || []).length,
          triggerCollectionHandles: cfg.triggerCollectionHandles || [],
          minQty: cfg.minQty,
          minAmount: cfg.minAmount,
          cartTotal: cart.total_price,
          cartItemCount: cart.item_count,
          giftUnavailable: this._giftUnavailable
        };

        if (this._giftUnavailable) {
          status.ok = false;
          status.reason = 'gift_unavailable';
          return status;
        }

        if (cfg.triggerProductIds && cfg.triggerProductIds.length > 0) {
          const triggerItems = items.filter(item => cfg.triggerProductIds.includes(item.product_id));
          status.triggerItems = triggerItems.map(item => ({
            key: item.key,
            product_id: item.product_id,
            variant_id: item.variant_id,
            quantity: item.quantity,
            final_line_price: item.final_line_price,
            isGift: !!(item.properties && item.properties._omaggio === 'true')
          }));

          if (!triggerItems.length) {
            status.ok = false;
            status.reason = 'missing_trigger_product';
            return status;
          }
        }

        if (cfg.minQty !== null && cfg.minQty !== undefined) {
          if (cfg.triggerMode === 'products') {
            const productQtyMatches = items
              .filter(item => cfg.triggerProductIds.includes(item.product_id))
              .map(item => ({
                product_id: item.product_id,
                variant_id: item.variant_id,
                quantity: item.quantity
              }));
            status.productQtyMatches = productQtyMatches;

            const hasSufficientQty = productQtyMatches.some(item => item.quantity >= cfg.minQty);
            if (!hasSufficientQty) {
              status.ok = false;
              status.reason = 'insufficient_product_quantity';
              return status;
            }
          } else {
            const triggerQty = items.reduce((sum, item) =>
              (cfg.triggerProductIds && cfg.triggerProductIds.includes(item.product_id))
                ? sum + item.quantity : sum, 0);
            status.triggerQty = triggerQty;

            if (triggerQty < cfg.minQty) {
              status.ok = false;
              status.reason = 'insufficient_collection_quantity';
              return status;
            }
          }
        }

        if (cfg.minAmount !== null && cfg.minAmount !== undefined && cfg.minAmount > 0) {
          if (cart.total_price < cfg.minAmount) {
            status.ok = false;
            status.reason = 'insufficient_cart_amount';
            return status;
          }
        }

        if (cfg.requiredCoupon && cfg.requiredCoupon.trim() !== '') {
          const required = cfg.requiredCoupon.trim().toLowerCase();
          const codes = (cart.discount_codes || [])
            .filter(d => d.applicable !== false)
            .map(d => (d.code || '').toLowerCase());
          status.requiredCoupon = required;
          status.activeCouponCodes = codes;

          if (!codes.includes(required)) {
            const pending = pendingCouponCode && pendingCouponCode.toLowerCase() === required;
            if (!pending) {
              status.ok = false;
              status.reason = 'missing_required_coupon';
              return status;
            }
          }
        }

        return status;
      }

      selectVariant(cart) {
        const variants = this.config.giftVariants;
        const options = this.config.giftOptions || [];

        if (!variants || variants.length === 0) return null;
        if (variants.length === 1) return variants[0];

        const manualId = parseInt(sessionStorage.getItem(this._variantKey()), 10);
        if (manualId) {
          const manualVariant = variants.find(v => v.id === manualId && v.available);
          if (manualVariant) return manualVariant;
          sessionStorage.removeItem(this._variantKey());
        }

        const sizeIdx = options.findIndex(o => /taglia|size|misura/i.test(o.name));

        if (sizeIdx === -1) {
          return variants.find(v => v.available) || variants[0];
        }

        const sizeKey = 'option' + (sizeIdx + 1);
        const giftSizes = [...new Set(variants.map(v => v[sizeKey]))];

        const counts = {};
        giftSizes.forEach(s => { counts[s] = 0; });

        (cart.items || [])
          .filter(item =>
            this.config.triggerProductIds.includes(item.product_id) &&
            !(item.properties && item.properties._omaggio === 'true')
          )
          .forEach(item => {
            (item.variant_title || '').split(' / ').forEach(part => {
              const t = part.trim();
              if (Object.prototype.hasOwnProperty.call(counts, t)) counts[t] += item.quantity;
            });
          });

        let bestSize = null, max = 0;
        for (const [s, c] of Object.entries(counts)) {
          if (c > max) { max = c; bestSize = s; }
        }

        agLog(`selectVariant: conteggio taglie (giftProductId: ${this.config.giftProductId})`, { counts, bestSize, max });

        if (!bestSize) return variants.find(v => v.available) || variants[0];

        return variants.find(v => v[sizeKey] === bestSize && v.available)
          || variants.find(v => v[sizeKey] === bestSize)
          || variants.find(v => v.available)
          || variants[0];
      }

      checkConditions(cart, pendingCouponCode = null) {
        return this._getConditionStatus(cart, pendingCouponCode).ok;
      }

      findAllGiftItems(cart) {
        return (cart.items || []).filter(item =>
          item.product_id === this.config.giftProductId &&
          item.properties && item.properties._omaggio === 'true'
        );
      }

      findGiftItem(cart) {
        return this.findAllGiftItems(cart)[0] || null;
      }

      _siblingCheck(cart) {
        const cfg = this.config;
        return (window._nobileAutoGiftInstances || []).some(inst =>
          inst !== this &&
          inst.config.giftProductId === cfg.giftProductId &&
          inst.checkConditions(cart, inst._pendingCouponCode)
        );
      }

      _autoRemoveKey() {
        return `nobileGiftAutoRemoving_${this.config.giftProductId}`;
      }

      _markAutoRemoval(reason) {
        sessionStorage.setItem(this._autoRemoveKey(), JSON.stringify({
          reason,
          at: Date.now()
        }));
      }

      _consumeRecentAutoRemoval() {
        const key = this._autoRemoveKey();
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;

        let data = null;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          sessionStorage.removeItem(key);
          return null;
        }

        if (!data || !data.at || Date.now() - data.at > 5000) {
          sessionStorage.removeItem(key);
          return null;
        }

        sessionStorage.removeItem(key);
        return data;
      }

      _giftAddKey() {
        return String(this.config.giftProductId);
      }

      _giftAddLocks() {
        window._nobileAutoGiftAddLocks = window._nobileAutoGiftAddLocks || {};
        return window._nobileAutoGiftAddLocks;
      }

      _isGiftAddLocked() {
        const locks = this._giftAddLocks();
        const key = this._giftAddKey();
        const lock = locks[key];
        if (!lock) return false;
        if (Date.now() - lock.at > 10000) {
          delete locks[key];
          return false;
        }
        return true;
      }

      _lockGiftAdd(reason) {
        this._giftAddLocks()[this._giftAddKey()] = {
          reason,
          at: Date.now()
        };
      }

      _unlockGiftAdd() {
        delete this._giftAddLocks()[this._giftAddKey()];
      }

      // Chiave condivisa tra tutte le regole con lo stesso giftProductId: intenzionale.
      // Se l'utente rimuove il regalo manualmente, nessuna altra regola deve re-aggiungerlo.
      _declinedKey() { return `nobileGiftDeclined_${this.config.giftProductId}`; }
      _variantKey()  { return `nobileGiftVariant_${this.config.giftProductId}`; }
      _removalEventsAttributeKey() { return '_autoGiftRemovedEvents'; }
      _removalRecordKey(giftItem) {
        return `nobileGiftRemovalRecorded_${this.config.giftProductId}_${giftItem && giftItem.key ? giftItem.key : 'unknown'}`;
      }

      _buildGiftProperties() {
        const p = { _omaggio: 'true' };
        if (this.config.giftLabel) p._gift_label = this.config.giftLabel;
        return p;
      }

      _findVariantFromSelects(selects) {
        const selectedOptions = {};

        selects.forEach(select => {
          const pos = parseInt(select.dataset.omaggioOptionPos, 10);
          if (!isNaN(pos)) selectedOptions[`option${pos}`] = select.value;
        });

        const matchesSelectedOptions = variant => Object.entries(selectedOptions)
          .every(([key, value]) => String(variant[key]) === String(value));

        return this.config.giftVariants.find(variant => matchesSelectedOptions(variant) && variant.available) || null;
      }

      async _recordGiftRemoval(giftItem, cart) {
        if (!giftItem || !AUTOGIFT_ATTRIBUTES_ENABLED) return;

        const recordKey = this._removalRecordKey(giftItem);
        const lastRecordedAt = parseInt(sessionStorage.getItem(recordKey), 10);
        if (lastRecordedAt && Date.now() - lastRecordedAt < 10000) return;
        sessionStorage.setItem(recordKey, String(Date.now()));

        try {
          const latestCart = (cart && cart.attributes) ? cart : await this._fetchCart().catch(() => cart || {});
          const attributeKey = this._removalEventsAttributeKey();
          const attributes = (latestCart && latestCart.attributes) || {};
          let removedProducts = {};

          if (attributes[attributeKey]) {
            try {
              removedProducts = JSON.parse(attributes[attributeKey]);
              if (!removedProducts || Array.isArray(removedProducts) || typeof removedProducts !== 'object') {
                removedProducts = {};
              }
            } catch (e) {
              removedProducts = {};
            }
          }

          removedProducts[String(giftItem.product_id || this.config.giftProductId)] =
            giftItem.product_title || giftItem.title || null;

          this._invalidateCart();
          const response = await fetch(`${this.cartRoute}/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { [attributeKey]: JSON.stringify(removedProducts) } })
          });

          if (!response.ok) throw new Error(`update attributes failed: ${response.status}`);
        } catch (err) {
          console.error('[NobileAutoGift] record gift removal error:', err);
          sessionStorage.removeItem(recordKey);
        }
      }

      /* GG MOD START - diagnostica: restituisce l'esito (true/false) invece di scartarlo */
      async _withProcessing(fn, errorLabel) {
        this._processing = true;
        try { await fn(); return true; }
        catch (e) { console.error(`[NobileAutoGift] ${errorLabel}:`, e); return false; }
        finally { this._processing = false; }
      }
      /* GG MOD END */

      /* GG MOD START - diagnostica: addGift annota il proprio esito in _lastAddOutcome.
         Il valore di ritorno resta booleano perché il pre-submit del coupon lo usa come tale. */
      async addGift(cart, suppressEvents = false, allowPendingCoupon = false) {
        if (this._isGiftAddLocked()) {
          agLog(`addGift skip: lock attivo (giftProductId: ${this.config.giftProductId})`, this._giftAddLocks()[this._giftAddKey()]);
          this._lastAddOutcome = 'add_skipped:lock';
          return false;
        }

        this._lockGiftAdd('addGift');
        // Resta così solo se qualcosa lancia prima di un esito noto (rete, JSON)
        this._lastAddOutcome = 'add_error';

        try {
          const latestCart = await this._fetchCart().catch(() => cart);
          const pendingCouponCode = allowPendingCoupon ? this._pendingCouponCode : null;
          const conditionStatus = this._getConditionStatus(latestCart, pendingCouponCode);
          if (!conditionStatus.ok) {
            agLog(`addGift skip: condizioni non soddisfatte (${conditionStatus.reason})`, conditionStatus);
            this._lastAddOutcome = `add_skipped:${conditionStatus.reason}`;
            return false;
          }

          const existingGiftItem = this.findGiftItem(latestCart);
          if (existingGiftItem) {
            agLog('addGift skip: regalo già presente in carrello', { key: existingGiftItem.key, variant_id: existingGiftItem.variant_id });
            this._lastAddOutcome = 'gift_in_cart';
            return false;
          }

          const bestVariant = this.selectVariant(latestCart);
          const variantId = bestVariant ? bestVariant.id : this.config.giftVariants[0].id;
          const properties = this._buildGiftProperties();

          agLog(`addGift: aggiungo variante ${variantId}`, { variantTitle: bestVariant ? bestVariant.title : null, qty: this.config.giftQty, properties, suppressEvents, pendingCouponCode });

          this._invalidateCart();
          const response = await fetch(`${this.cartRoute}/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: this.config.giftQty,
              properties
            })
          });

          if (!response.ok) {
            this._lastAddOutcome = `add_failed:${response.status}`;
            if (response.status === 422) {
              this._giftUnavailable = true;
              this._lastAddOutcome = `unavailable:${variantId}`;
              agLog(`addGift: HTTP 422 — variante ${variantId} non disponibile, regalo disattivato per questa sessione`);
            }
            const err = await response.json().catch(() => ({}));
            throw new Error(`addGift failed: ${response.status} — ${err.description || 'unknown'}`);
          }

          await response.json();
          agLog('addGift: regalo aggiunto con successo');
          this._lastAddOutcome = 'added';
          if (!suppressEvents) {
            const updatedCart = await this._fetchCart();
            this._dispatchCartEvents(updatedCart);
          }
          return true;
        } finally {
          this._unlockGiftAdd();
        }
      }
      /* GG MOD END */

      /* Regole diverse possono puntare allo stesso regalo: quando le condizioni
         decadono per tutte, ognuna proverebbe a rimuovere la stessa riga e solo la
         prima la troverebbe ancora lì. Le chiamate concorrenti condividono una sola
         richiesta, come per le collection. */
      _removalLocks() {
        return (window._nobileAutoGiftRemovalLocks = window._nobileAutoGiftRemovalLocks || {});
      }

      removeGift(giftItem) {
        const locks = this._removalLocks();
        const lineKey = giftItem.key;

        if (locks[lineKey]) {
          agLog(`removeGift: riga ${lineKey} già in rimozione da un'altra regola, ne riuso l'esito`);
          return locks[lineKey];
        }

        // Il lock va rilasciato prima che la promise si risolva, altrimenti una
        // rimozione immediatamente successiva riuserebbe l'esito di questa.
        const request = this._performGiftRemoval(giftItem)
          .finally(() => { delete locks[lineKey]; });
        locks[lineKey] = request;
        return request;
      }

      async _performGiftRemoval(giftItem) {
        this._invalidateCart();
        const response = await fetch(`${this.cartRoute}/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });

        if (!response.ok) {
          /* La riga può essere sparita nel frattempo (altra regola, click dell'utente,
             carrello svuotato): l'obiettivo è comunque raggiunto, non è un errore. */
          this._invalidateCart();
          const latestCart = await this._fetchCart().catch(() => null);
          if (latestCart && !(latestCart.items || []).some(item => item.key === giftItem.key)) {
            agLog(`removeGift: riga ${giftItem.key} già assente dal carrello, nulla da fare`);
            this._dispatchCartEvents(latestCart);
            return latestCart;
          }

          const err = await response.json().catch(() => ({}));
          throw new Error(`removeGift failed: ${response.status} — ${err.description || 'unknown'}`);
        }

        const updatedCart = await response.json();
        agLog(`removeGift: rimossa riga ${giftItem.key}`, { cartTotal: updatedCart.total_price, itemCount: updatedCart.item_count });
        this._dispatchCartEvents(updatedCart);
        return updatedCart;
      }

      /* GG MOD START - diagnostica: sync è un involucro che registra in autoGiftDiag l'esito
         restituito da _sync. Il try/catch evita che un'eccezione (es. storage non accessibile)
         fermi la regola senza lasciare traccia. I sync scartati alzano il flag +skip: se
         il carrello scartato non è riconciliato e nessuna valutazione successiva lo azzera,
         l'evento è andato perso (caso 2.5 dell'analisi). */
      async sync(cart) {
        if (this._processing) {
          agLog(`sync skip: elaborazione in corso (giftProductId: ${this.config.giftProductId})`);
          this._skippedCart = cart;
          autoGiftDiag.record(this, null, null);
          return;
        }
        this._skippedCart = null;
        let outcome;
        try {
          outcome = await this._sync(cart);
        } catch (e) {
          console.error('[NobileAutoGift] sync error:', e);
          outcome = `error:${String(e && e.message || e).slice(0, 60)}`;
        }
        autoGiftDiag.record(this, outcome || 'unknown', cart);
      }

      /* Il carrello è coerente con la regola: regalo presente se le condizioni sono
         soddisfatte (o rifiutato dall'utente), assente altrimenti (o tenuto da una regola sorella). */
      _isReconciled(cart) {
        const status = this._getConditionStatus(cart, this._pendingCouponCode);
        const hasGift = !!this.findGiftItem(cart);
        if (status.ok) return hasGift || !!this._declinedCause();
        return !hasGift || this._siblingCheck(cart);
      }

      /* Causa del rifiuto: 'click' (rimozione esplicita dell'utente) o 'heuristic' (dedotta
         da sync vedendo il regalo sparito). Il vecchio valore 'true' vale come 'click'. */
      _declinedCause() {
        try {
          const value = sessionStorage.getItem(this._declinedKey());
          if (!value) return null;
          return value === 'true' ? 'click' : value;
        } catch (e) {
          return null;
        }
      }

      async _sync(cart) {
        this._lastCart = cart;
        this._primeCart(cart);

        const cfg = this.config;
        const isCouponMode = !!(cfg.requiredCoupon && cfg.requiredCoupon.trim());
        const activeConditionStatus = this._getConditionStatus(cart);
        const pendingConditionStatus = this._getConditionStatus(cart, this._pendingCouponCode);
        const allGiftItems = this.findAllGiftItems(cart);
        const giftItem = allGiftItems[0] || null;
        const conditionStatus = giftItem ? pendingConditionStatus : activeConditionStatus;
        const conditionsOk = conditionStatus.ok;

        agLog(`sync (giftProductId: ${cfg.giftProductId})`, {
          couponMode: isCouponMode,
          conditionsOk,
          reason: conditionStatus.reason,
          giftInCart: !!giftItem,
          giftItemsCount: allGiftItems.length,
          giftFinalPrice: giftItem ? giftItem.final_price : null,
          pendingCoupon: this._pendingCouponCode,
          declined: this._declinedCause(),
          giftWasPresent: this._giftWasPresent,
          cartTotal: cart.total_price,
          cartItemCount: cart.item_count,
          activeStatus: activeConditionStatus,
          pendingStatus: pendingConditionStatus
        });

        if (!isCouponMode) {
          if (conditionsOk && !giftItem && this._giftWasPresent) {
            const autoRemoval = this._consumeRecentAutoRemoval();
            if (autoRemoval) {
              agLog('sync: regalo sparito per auto-rimozione recente, non lo marco come rifiutato', autoRemoval);
              this._giftWasPresent = false;
              return `gift_gone:auto_removed_${autoRemoval.reason || 'unknown'}`;
            }
            // Intenzionale: _declinedKey è condiviso tra regole con stesso giftProductId.
            // Se l'utente rimuove il regalo manualmente, nessuna regola deve re-aggiungerlo
            // finché non passa al checkout (che pulisce la chiave).
            /* GG MOD START - diagnostica: se il clic è già stato visto (da questa o da una regola
               sorella con lo stesso regalo) resta la causa 'click', non va sovrascritta */
            const knownCause = this._declinedCause();
            if (knownCause) {
              this._giftWasPresent = false;
              return `declined:${knownCause}`;
            }
            /* GG MOD END */
            agLog('sync: regalo rimosso manualmente dall\'utente — marco come rifiutato fino al checkout');
            sessionStorage.setItem(this._declinedKey(), 'heuristic');
            this._giftWasPresent = false;
            return 'declined:heuristic';
          }
          this._giftWasPresent = !!(conditionsOk && giftItem);
          const declinedCause = this._declinedCause();
          if (conditionsOk && !giftItem && declinedCause) {
            agLog('sync: condizioni ok ma regalo rifiutato in precedenza, non lo ri-aggiungo');
            return `declined:${declinedCause}`;
          }
        }

        if (giftItem) {
          const giftAtFullPrice = isCouponMode && !this._pendingCouponCode && giftItem.final_price > 0;

          if (!conditionsOk || giftAtFullPrice) {
            agLog(`sync: valuto rimozione regalo — reason: ${conditionStatus.reason}, giftAtFullPrice: ${giftAtFullPrice}`);
            if (isCouponMode && !giftAtFullPrice && this._pendingCouponCode) {
              agLog('sync: coupon in attesa di applicazione, mantengo il regalo');
              return 'kept:pending_coupon';
            }
            if (!giftAtFullPrice && this._siblingCheck(cart)) {
              agLog('sync: un\'altra regola sullo stesso regalo è soddisfatta, mantengo');
              return 'kept:sibling';
            }
            agLog('sync: rimuovo il regalo dal carrello');
            const removed = await this._withProcessing(async () => {
              if (!isCouponMode) {
                this._markAutoRemoval(conditionStatus.reason);
                sessionStorage.removeItem(this._variantKey());
              }
              await this.removeGift(giftItem);
              if (!isCouponMode) this._giftWasPresent = false;
            }, 'sync remove');
            return removed
              ? `auto_removed:${giftAtFullPrice ? 'full_price' : conditionStatus.reason}`
              : 'remove_error';
          }

          // Rimuovi eventuali duplicati (items aggiuntivi con stesso product_id e _omaggio=true)
          if (allGiftItems.length > 1) {
            const duplicates = allGiftItems.slice(1);
            agLog(`sync: trovati ${allGiftItems.length} regali duplicati, ne rimuovo ${duplicates.length} in un'unica update.js`);
            const deduped = await this._withProcessing(async () => {
              const updates = {};
              duplicates.forEach(dup => { updates[dup.key] = 0; });
              const updatedCart = await this._updateCartLines(updates);
              this._dispatchCartEvents(updatedCart);
            }, 'sync remove duplicates');
            return deduped ? 'gift_in_cart:dedup' : 'dedup_error';
          }

          agLog('sync: regalo presente e condizioni soddisfatte, nulla da fare');
          return 'gift_in_cart';
        }

        if (!conditionsOk) {
          agLog(`sync: nessun regalo e condizioni non soddisfatte (${conditionStatus.reason}), nulla da fare`);
          return `not_met:${conditionStatus.reason}`;
        }

        agLog('sync: condizioni soddisfatte e regalo assente, procedo con l\'aggiunta');
        this._lastAddOutcome = null;
        const addDone = await this._withProcessing(async () => {
          await this.addGift(cart);
          if (!isCouponMode) this._giftWasPresent = true;
        }, 'sync add');
        return this._lastAddOutcome || (addDone ? 'added' : 'add_error');
      }
      /* GG MOD END */

      init() {
        document.addEventListener('theme:cart:change', (event) => {
          if (event.detail && event.detail.cart) {
            this.sync(event.detail.cart);
          }
        });

        document.addEventListener('click', async (e) => {
          const cfg = this.config;
          if (!cfg.triggerProductIds || !cfg.triggerProductIds.length) return;
          const cart = this._lastCart;
          if (!cart) return;

          const isMinusBtn = !!e.target.closest('[data-decrease-quantity]');
          const isRemoveLink = !!e.target.closest('[data-remove-key]');
          if (!isMinusBtn && !isRemoveLink) return;

          const row = e.target.closest('[data-cart-item]');
          if (!row) return;

          let itemKey;
          if (isRemoveLink) {
            const link = e.target.closest('[data-remove-key]');
            itemKey = link && link.dataset.removeKey;
          } else {
            const input = row.querySelector('[data-update-cart]');
            itemKey = input && input.dataset.updateCart;
          }
          if (!itemKey) return;

          const item = (cart.items || []).find(i => i.key === itemKey);
          if (!item) return;

          if (isRemoveLink && item.product_id === this.config.giftProductId && item.properties && item.properties._omaggio === 'true') {
            e.stopImmediatePropagation();
            e.preventDefault();

            agLog('click: rimozione manuale del regalo da parte dell\'utente');
            await this._withProcessing(async () => {
              /* GG MOD START - diagnostica: la causa distingue il rifiuto esplicito da quello dedotto in sync.
                 Va scritta prima della rimozione: le regole sorelle sincronizzano sull'evento del carrello
                 e senza causa segnerebbero un secondo rifiuto 'heuristic'. */
              sessionStorage.setItem(this._declinedKey(), 'click');
              const updatedCart = await this.removeGift(item);
              /* GG MOD END */
              sessionStorage.removeItem(this._variantKey());
              this._giftWasPresent = false;
              await this._recordGiftRemoval(item, updatedCart);
            }, 'manual gift remove');

            return;
          }

          /* GG MOD START - gruppi multi-riga: la simulazione userebbe la quantità della sola riga
             rappresentativa invece del totale di gruppo. Lascia agire l'handler di gruppo
             (NobileCartGroup): il resync arriva comunque dal listener theme:cart:change. */
          const _groupCount = parseInt((row.dataset && row.dataset.groupCount) || '1', 10);
          if (_groupCount > 1) return;
          /* GG MOD END */

          if (!cfg.triggerProductIds.includes(item.product_id)) return;

          const giftItem = this.findGiftItem(cart);
          if (!giftItem) return;

          const newQty = isRemoveLink ? 0 : Math.max(0, item.quantity - 1);
          const simulatedItems = cart.items.map(i =>
            i.key === itemKey ? { ...i, quantity: newQty } : i
          );
          const simulatedCart = { ...cart, items: simulatedItems };

          const simulatedStatus = this._getConditionStatus(simulatedCart);
          agLog(`click: simulazione qty ${item.quantity} -> ${newQty} sulla riga ${itemKey}`, { stillOk: simulatedStatus.ok, reason: simulatedStatus.reason });
          if (simulatedStatus.ok) return;

          /* GG MOD START - regole sorelle: se un'altra regola con lo stesso regalo resta soddisfatta
             dopo la modifica, il regalo le spetta ancora. Senza questo controllo il regalo veniva tolto
             insieme alla riga e la regola sorella lo marcava come rifiutato ('declined:heuristic'),
             senza più riaggiungerlo (ordini #37325, #37402, #37411 della promo di settembre 2026).
             Qui si lascia agire il tema; la sync successiva tiene il regalo con 'kept:sibling'. */
          if (this._siblingCheck(simulatedCart)) {
            agLog('click: regola non più soddisfatta ma una regola sorella sì, il regalo resta');
            return;
          }
          /* GG MOD END */

          e.stopImmediatePropagation();
          e.preventDefault();

          const updates = {};
          updates[itemKey] = newQty;
          updates[giftItem.key] = 0;
          sessionStorage.removeItem(this._variantKey());
          /* GG MOD START - rimozione del regalo decisa dal tema, non dal cliente: va segnata come
             automatica, altrimenti una regola sorella che lo vede sparire la scambia per un rifiuto */
          this._markAutoRemoval('click_trigger');
          /* GG MOD END */

          try {
            const updatedCart = await this._updateCartLines(updates);
            agLog('click: rimozione batch (riga trigger + regalo) completata');
            this._lastCart = updatedCart;
            this._giftWasPresent = false;
            this._dispatchCartEvents(updatedCart);
          } catch (err) {
            console.error('[NobileAutoGift] batched remove error:', err);
          }
        }, true);

        document.addEventListener('click', (event) => {
          if (event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-checkout-button]')) {
            sessionStorage.removeItem(this._declinedKey());
          }
        });

        document.addEventListener('change', async (e) => {
          const sel = e.target.closest('[data-omaggio-select]');
          if (!sel) return;

          const wrapper = sel.closest('[data-omaggio-selects]');
          if (!wrapper) return;
          if (parseInt(wrapper.dataset.omaggioProductId, 10) !== this.config.giftProductId) return;
          if (this._isGiftAddLocked()) return;

          const itemKey = wrapper.dataset.omaggioItemKey;
          const selects = [...wrapper.querySelectorAll('[data-omaggio-select]')];
          const newVariant = this._findVariantFromSelects(selects);
          if (!itemKey || !newVariant) return;

          agLog(`select: cambio variante regalo -> ${newVariant.id} (${newVariant.title || ''})`, { itemKey });
          selects.forEach(select => { select.disabled = true; });
          sessionStorage.setItem(this._variantKey(), String(newVariant.id));
          this._lockGiftAdd('selectChange');
          try {
            this._invalidateCart();
            const removeResp = await fetch(`${this.cartRoute}/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemKey, quantity: 0 })
            });
            if (!removeResp.ok) throw new Error(`remove failed: ${removeResp.status}`);
            this._invalidateCart();
            const addResp = await fetch(`${this.cartRoute}/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: newVariant.id, quantity: this.config.giftQty, properties: this._buildGiftProperties() })
            });
            if (!addResp.ok) throw new Error(`add failed: ${addResp.status}`);
            await addResp.json();
            const updatedCart = await this._fetchCart();
            this._dispatchCartEvents(updatedCart);
          } catch (err) {
            console.error('[NobileAutoGift] select change error:', err);
            sessionStorage.removeItem(this._variantKey());
            selects.forEach(select => { select.disabled = false; });
          } finally {
            this._unlockGiftAdd();
          }
        });

        agLog(`init: regola registrata (giftProductId: ${this.config.giftProductId})`, this.config);

        /* L'idratazione non tocca il DOM: parte subito, in parallelo al parsing della
           pagina, invece di accodarsi dopo DOMContentLoaded. */
        const hydration = this._hydrateCollectionProducts()
          .catch(err => console.error('[NobileAutoGift] hydrate error:', err));

        const bootstrap = () => {
          hydration
            .then(() => this._fetchCart())
            .then(cart => this.sync(cart))
            .catch(err => console.error('[NobileAutoGift] init error:', err));
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', bootstrap);
        } else {
          bootstrap();
        }

        (window._nobileAutoGiftInstances = window._nobileAutoGiftInstances || []).push(this);
      }

      _collectionCacheKey(handle) { return `nobileGiftColl_${handle}`; }

      _readCollectionCache(handle) {
        // Con il debug attivo la cache viene ignorata: serve lo stato reale delle collection
        if (autoGiftDebugEnabled()) return null;
        try {
          const raw = localStorage.getItem(this._collectionCacheKey(handle));
          if (!raw) return null;
          const data = JSON.parse(raw);
          if (!data || !Array.isArray(data.ids) || !data.at) return null;
          if (Date.now() - data.at > AUTOGIFT_COLLECTION_TTL) {
            localStorage.removeItem(this._collectionCacheKey(handle));
            return null;
          }
          return data.ids;
        } catch (e) {
          return null;
        }
      }

      _writeCollectionCache(handle, ids) {
        try {
          localStorage.setItem(this._collectionCacheKey(handle), JSON.stringify({ at: Date.now(), ids }));
        } catch (e) { /* quota piena o storage non accessibile: si prosegue senza cache */ }
      }

      _fetchCollectionProductIds(handle) {
        const cached = this._readCollectionCache(handle);
        if (cached) {
          agLog(`hydrate: "${handle}" da cache (${cached.length} id)`);
          return Promise.resolve({ ids: cached, complete: true }); // GG MOD - diagnostica: stessa forma della fetch
        }

        // Regole diverse possono condividere la stessa collection: una sola richiesta per handle
        const inFlight = (window._nobileAutoGiftCollFetches = window._nobileAutoGiftCollFetches || {});
        if (inFlight[handle]) {
          agLog(`hydrate: "${handle}" già in corso, riuso la richiesta`);
          return inFlight[handle];
        }

        /* GG MOD START - diagnostica: la promise restituisce { ids, complete } invece dei soli id */
        const request = (async () => {
          const ids = [];
          let page = 1;
          let complete = false;
          while (true) {
            const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`);
            if (!res.ok) {
              agLog(`hydrate: "${handle}" HTTP ${res.status} alla pagina ${page} — collection non pubblicata sul canale Online Store, oppure errore temporaneo`);
              break;
            }
            const data = await res.json();
            const products = data.products || [];
            products.forEach(p => ids.push(p.id));
            if (products.length < 250) { complete = true; break; }
            page++;
          }
          // In cache solo un elenco completo: un parziale (pagina fallita, collection
          // non ancora pubblicata) resterebbe valido per tutto il TTL. Se il caricamento
          // si interrompe prima — errore o abbandono della pagina — non si scrive nulla
          // e al caricamento successivo la collection viene richiesta di nuovo.
          if (complete && ids.length) this._writeCollectionCache(handle, ids);
          agLog(`hydrate: "${handle}" scaricata (${ids.length} id)${complete ? '' : ' — PARZIALE, non messa in cache'}`);
          return { ids, complete };
        })();
        /* GG MOD END */

        inFlight[handle] = request;
        request.catch(() => {}).then(() => { delete inFlight[handle]; });
        return request;
      }

      async _hydrateCollectionProducts() {
        const handles = (this.config.triggerCollectionHandles || []).filter(Boolean);
        if (!handles.length) return;
        agLog(`hydrate: carico i prodotti delle collection trigger`, handles);

        /* GG MOD START - diagnostica: una collection fallita o incompleta rende l'idratazione 'partial' */
        const results = await Promise.all(handles.map(handle =>
          this._fetchCollectionProductIds(handle).catch(e => {
            console.error(`[NobileAutoGift] hydrate collection "${handle}" error:`, e);
            return { ids: [], complete: false };
          })
        ));
        this._hydration = results.every(r => r.complete) ? 'ok' : 'partial';

        const existing = new Set(this.config.triggerProductIds);
        results.forEach(({ ids }) => ids.forEach(id => {
          if (!existing.has(id)) {
            existing.add(id);
            this.config.triggerProductIds.push(id);
          }
        }));
        /* GG MOD END */

        agLog(`hydrate: triggerProductIds dopo idratazione: ${this.config.triggerProductIds.length}`, this.config.triggerProductIds);
      }

      /* Cart store condiviso fra tutte le regole: senza, ogni istanza legge /cart.js
         per conto suo negli stessi millisecondi. Ogni scrittura sul carrello invalida
         il record, così nessuno riceve uno stato anteriore alla propria mutazione. */
      _cartStore() {
        return (window._nobileAutoGiftCart = window._nobileAutoGiftCart || { promise: null, at: 0 });
      }

      _invalidateCart() {
        const store = this._cartStore();
        store.promise = null;
        store.at = 0;
      }

      /* Il carrello arrivato da un evento del tema è già fresco: registrandolo qui
         si evita la GET che seguirebbe subito dopo. */
      _primeCart(cart) {
        if (!cart || !cart.items) return;
        const store = this._cartStore();
        store.promise = Promise.resolve(cart);
        store.at = Date.now();
      }

      _fetchCart() {
        const store = this._cartStore();
        if (store.promise && Date.now() - store.at <= AUTOGIFT_CART_FRESH_MS) {
          return store.promise;
        }

        const request = fetch(`${this.cartRoute}.js`, {
          headers: { 'Content-Type': 'application/json' }
        }).then(response => {
          if (!response.ok) throw new Error(`_fetchCart failed: ${response.status}`);
          return response.json();
        });

        store.promise = request;
        store.at = Date.now();
        request.catch(() => {
          if (store.promise === request) this._invalidateCart();
        });
        return request;
      }

      async _updateCartLines(updates) {
        this._invalidateCart();
        const response = await fetch(`${this.cartRoute}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(`update.js failed: ${response.status} — ${err.description || 'unknown'}`);
        }
        return response.json();
      }

      _dispatchCartEvents(updatedCart) {
        this._primeCart(updatedCart);
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true, detail: { cart: updatedCart }
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      }
    }

    const _autoGiftRules = window.nobileAutoGiftRules || [];
    agLog(`bootstrap: ${_autoGiftRules.length} regola/e regalo da window.nobileAutoGiftRules`, _autoGiftRules);
    _autoGiftRules.forEach(config => new NobileAutoGift(config).init());

    /* GG MOD END */
  
    // Add this helper function at the end of your IIFE
    function debugMobileUpsell() {
      //console.log('Window width:', window.innerWidth);
      //console.log('Is mobile:', window.innerWidth <= 768);
      //console.log('Cart drawer exists:', !!document.querySelector('.drawer__inner'));
      //console.log('Mobile upsell exists:', !!document.getElementById('mobile-cart-upsell'));
      //console.log('Product pools:', productPools);
      
      // Force insert for testing
      insertMobileUpsellSection();
    }
    
    // Make it globally accessible for testing in console
    //window.debugMobileUpsell = debugMobileUpsell;

  /* GG MOD START - cart drawer open tracking */
  (function() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;
    drawer.addEventListener('theme:drawer:open', function() {
      try {
        var ts = sessionStorage.getItem('_nobile_cart_btn_ts');
        var origin = sessionStorage.getItem('_nobile_cart_btn_page');
        sessionStorage.removeItem('_nobile_cart_btn_ts');
        sessionStorage.removeItem('_nobile_cart_btn_page');
        if (!ts) return;
        var age = Date.now() - parseInt(ts, 10);
        if (age > 15000) return;
        var params = {
          result: 'drawer_opened',
          device: (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) ? 'mobile' : 'desktop',
          origin_page: origin || '(unknown)'
        };
        if (window.gtag) {
          gtag('event', 'cart_button_click', params);
        } else if (window.dataLayer) {
          dataLayer.push(Object.assign({ event: 'cart_button_click' }, params));
        }
      } catch(err) {}
    });
  })();
  /* GG MOD END */

  /* GG MOD START - Firma di gruppo riga carrello (variante + selling plan + line item properties).
     Il carrello raggruppa in una sola riga le line item che il motore sconti può spezzare
     (paganti + gratuite), ma NON quelle con properties diverse (personalizzazioni prodotto,
     omaggio): quelle restano righe distinte, come al checkout.
     La firma calcolata qui non deve coincidere con l'md5 lato Liquid: deve solo essere
     coerente fra i data-group-* del DOM e gli item restituiti da /cart.js. */
  window.NobileCartGroup = (function() {
    function canonProps(props) {
      if (!props) return '[]';
      var entries = [];
      if (Array.isArray(props)) {
        props.forEach(function(p) {
          entries.push([String(p[0]), String(p[1] == null ? '' : p[1])]);
        });
      } else {
        Object.keys(props).forEach(function(k) {
          entries.push([String(k), String(props[k] == null ? '' : props[k])]);
        });
      }
      entries.sort(function(a, b) { return a[0] < b[0] ? -1 : (a[0] > b[0] ? 1 : 0); });
      return JSON.stringify(entries);
    }

    function fromItem(item) {
      var plan = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
        ? item.selling_plan_allocation.selling_plan.id
        : '';
      return 'v' + item.variant_id + '|s' + (plan || '') + '|p' + canonProps(item.properties);
    }

    function fromRow(row) {
      if (!row || !row.dataset || typeof row.dataset.groupVid === 'undefined') return null;
      var props = {};
      try { props = JSON.parse(row.dataset.groupProps || '{}'); } catch (err) { props = {}; }
      return 'v' + row.dataset.groupVid + '|s' + (row.dataset.groupPlan || '') + '|p' + canonProps(props);
    }

    function rowsFor(cart, sig) {
      return ((cart && cart.items) || []).filter(function(i) { return fromItem(i) === sig; });
    }

    function cartRoute() {
      return (window.theme && window.theme.routes && window.theme.routes.cart) ? window.theme.routes.cart : '/cart';
    }

    function lock(row) {
      var loadbar = row && row.querySelector('[data-item-loadbar]');
      if (loadbar) loadbar.style.display = 'block';
      var cartLoader = document.querySelector('[data-cart-loading]');
      if (cartLoader) cartLoader.classList.add('cart--loading');
      document.querySelectorAll('[data-remove-key], [data-quantity-selector]').forEach(function(el) {
        el.style.pointerEvents = 'none';
        el.setAttribute('aria-disabled', 'true');
      });
    }

    function unlock() {
      document.querySelectorAll('[data-remove-key], [data-quantity-selector]').forEach(function(el) {
        el.style.pointerEvents = '';
        el.removeAttribute('aria-disabled');
      });
      var cartLoader = document.querySelector('[data-cart-loading]');
      if (cartLoader) cartLoader.classList.remove('cart--loading');
    }

    function batchUpdate(updates) {
      return fetch(cartRoute() + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(r) { return r.ok ? r.json() : null; });
    }

    function refresh(cart) {
      if (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }

    return {
      fromItem: fromItem,
      fromRow: fromRow,
      rowsFor: rowsFor,
      cartRoute: cartRoute,
      lock: lock,
      unlock: unlock,
      batchUpdate: batchUpdate,
      refresh: refresh
    };
  })();
  /* GG MOD END */

  /* GG MOD START - Rimozione delle righe aggregate del solo gruppo (variante + properties + selling plan) */
  (function() {
    var G = window.NobileCartGroup;

    document.addEventListener('click', function(e) {
      var link = e.target.closest('[data-remove-keys]');
      if (!link) return;

      var row = link.closest('[data-cart-item]');
      var sig = G.fromRow(row);
      var fallbackKeys = (link.getAttribute('data-remove-keys') || '').split('|').filter(Boolean);
      if (!sig && !fallbackKeys.length) return;

      e.preventDefault();
      e.stopImmediatePropagation(); // blocca CartItems.initRemove di theme.js

      G.lock(row);

      // Azzera in un'unica update.js tutte le key del gruppo: essendo atomica, il motore
      // sconti non può ri-splittare la variante fra una chiamata e l'altra.
      function pass(cart, attempt) {
        var keys = sig ? G.rowsFor(cart, sig).map(function(i) { return i.key; }) : [];
        if (!keys.length && attempt === 0) keys = fallbackKeys.slice();
        if (!keys.length) return Promise.resolve(cart);

        var updates = {};
        keys.forEach(function(k) { updates[k] = 0; });

        return G.batchUpdate(updates).then(function(next) {
          if (!next) return cart;
          if (!sig || attempt >= 1) return next;
          return G.rowsFor(next, sig).length ? pass(next, attempt + 1) : next;
        });
      }

      // Il GET iniziale costa una richiesta ma evita di lavorare con key stale nel DOM:
      // la firma si ricalcola dagli attributi della riga, validi anche se le key cambiano.
      fetch(G.cartRoute() + '.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { return pass(cart, 0); })
        .then(function(cart) { G.refresh(cart); })
        .catch(function(err) {
          console.error('[Nobile] Errore rimozione gruppo riga carrello:', err);
          G.unlock();
        });
    }, true); // capture: true
  })();
  /* GG MOD END */

  /* GG MOD START - Quantità di gruppo: distribuisce il delta sulle righe del gruppo (+/- e digitazione diretta) */
  (function() {
    var G = window.NobileCartGroup;

    document.addEventListener('change', function(e) {
      var input = e.target && e.target.closest && e.target.closest('[data-quantity-input][data-update-cart]');
      if (!input) return;

      var row = input.closest('[data-cart-item]');
      var groupCount = parseInt((row && row.dataset.groupCount) || '1', 10);
      if (!(groupCount > 1)) return; // gruppo a riga singola: gestione standard di theme.js

      var sig = G.fromRow(row);
      if (!sig) return;

      // I pulsanti +/- di theme.js scrivono già "valore visualizzato ± 1", cioè il totale
      // di gruppo desiderato: stesso identico input della digitazione manuale.
      var desired = parseInt(input.value, 10);
      if (isNaN(desired) || desired < 0) desired = 0;

      e.preventDefault();
      e.stopImmediatePropagation(); // blocca CartItems.initInputs di theme.js

      G.lock(row);

      fetch(G.cartRoute() + '.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var rows = G.rowsFor(cart, sig);
          if (!rows.length) return cart;

          var total = rows.reduce(function(s, i) { return s + i.quantity; }, 0);
          var delta = desired - total;
          if (delta === 0) return cart;

          // Righe paganti prima (prezzo unitario finale decrescente), gratuite per ultime.
          var ordered = rows.slice().sort(function(a, b) {
            return (b.final_price || 0) - (a.final_price || 0);
          });

          var updates = {};
          if (delta > 0) {
            // Incrementa la riga a prezzo pieno: aumentare una riga gratuita
            // produrrebbe un ricalcolo incoerente del motore sconti.
            var target = ordered[0];
            updates[target.key] = target.quantity + delta;
          } else {
            // Decrementa consumando prima le paganti: le gratuite spettanti
            // vengono poi ricalcolate dal motore sconti.
            var remaining = -delta;
            ordered.forEach(function(it) {
              if (remaining <= 0) return;
              var take = Math.min(it.quantity, remaining);
              updates[it.key] = it.quantity - take;
              remaining -= take;
            });
          }
          return G.batchUpdate(updates).then(function(next) { return next || cart; });
        })
        .then(function(cart) { G.refresh(cart); })
        .catch(function(err) {
          console.error('[Nobile] Errore aggiornamento quantità di gruppo:', err);
          G.unlock();
        });
    }, true); // capture: true
  })();
  /* GG MOD END */

  /* GG MOD START - PDP upsell selettore variante inline */
  (function() {
    let _pendingViewItems = [];
    let _viewItemListTimer = null;

    class NobileProductClipInline {
      constructor(el) {
        this.el = el;
        this.variants = JSON.parse(el.querySelector('[data-clip-variants]').textContent);
        this.selects = [...el.querySelectorAll('[data-clip-option]')];
        this.btn = el.querySelector('[data-clip-add]');
        this.selectedVariant = null;
        this.productId = el.dataset.productId || '';
        this.productTitle = el.dataset.productTitle || '';
        this.productPrice = parseFloat(el.dataset.productPrice || '0');
        this.productHandle = el.dataset.productHandle || '';
        this.slotIndex = parseInt(el.dataset.clipSlot || '0', 10);

        this.selects.forEach(s => s.addEventListener('change', () => this._updateVariant()));
        this.btn.addEventListener('click', () => this._addToCart());
        this._updateVariant();
      }

      _updateVariant() {
        const opts = this.selects.map(s => s.value);
        this.selectedVariant = this.variants.find(v =>
          opts.every((val, i) => v[`option${i + 1}`] === val)
        ) || null;
        this.btn.disabled = !(this.selectedVariant && this.selectedVariant.available);

        /* GG MOD START - disabilita <option> senza variante disponibile */
        this.selects.forEach((sel, i) => {
          [...sel.options].forEach(opt => {
            const testOpts = opts.map((v, j) => j === i ? opt.value : v);
            const hasAvailable = this.variants.some(v =>
              testOpts.every((val, j) => v[`option${j + 1}`] === val) && v.available
            );
            opt.disabled = !hasAvailable;
          });
        });
        /* GG MOD END */
      }

      async _addToCart() {
        if (!this.selectedVariant || !this.selectedVariant.available || this.btn.disabled) return;
        this.btn.classList.add('loading');
        this.btn.disabled = true;
        try {
          const addResp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: this.selectedVariant.id, quantity: 1, properties: { '_upsell_source': 'pdp' } })
          });
          if (!addResp.ok) throw new Error(`add.js failed: ${addResp.status}`);
          /* GG MOD START - GA4 add_to_cart tracking PDP upsell */
          if (window.gtag) {
            gtag('event', 'add_to_cart', {
              currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
              value: this.productPrice,
              item_list_id: 'pdp_upsell',
              item_list_name: 'PDP Upsell',
              items: [{
                item_id: String(this.productId),
                item_name: this.productTitle,
                item_variant: String(this.selectedVariant.id),
                item_list_id: 'pdp_upsell',
                item_list_name: 'PDP Upsell',
                index: this.slotIndex,
                quantity: 1,
                price: this.productPrice
              }]
            });
          }
          /* GG MOD END */
          const cartResp = await fetch('/cart.js');
          const cart = cartResp.ok ? await cartResp.json() : null;
          this.btn.classList.remove('loading');
          this.btn.classList.add('has-success');
          if (cart) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              bubbles: true, detail: { cart }
            }));
          }
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
          if (cartDrawer) cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
          setTimeout(() => {
            this.btn.classList.remove('has-success');
            this.btn.disabled = false;
          }, 2000);
        } catch (e) {
          console.error('[NobileProductClipInline] addToCart error:', e);
          this.btn.classList.remove('loading');
          this.btn.disabled = false;
        }
      }

      /* GG MOD START - GA4 view_item_list tracking PDP upsell */
      static _fireViewItemList(instances) {
        if (!window.gtag || !instances.length) return;
        gtag('event', 'view_item_list', {
          item_list_id: 'pdp_upsell',
          item_list_name: 'PDP Upsell',
          items: instances.map(inst => ({
            item_id: String(inst.productId),
            item_name: inst.productTitle,
            item_list_id: 'pdp_upsell',
            item_list_name: 'PDP Upsell',
            index: inst.slotIndex,
            price: inst.productPrice
          }))
        });
      }
      /* GG MOD END */

      static initSingle(el) {
        if (el.hasAttribute('data-clip-initialized')) return;
        el.setAttribute('data-clip-initialized', '');
        const inst = new NobileProductClipInline(el);
        /* GG MOD START - view_item_list solo quando il prodotto è visibile nel viewport */
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            _pendingViewItems.push(inst);
            clearTimeout(_viewItemListTimer);
            _viewItemListTimer = setTimeout(() => {
              NobileProductClipInline._fireViewItemList(_pendingViewItems);
              _pendingViewItems = [];
            }, 100);
          });
        }, { threshold: 0.5 });
        observer.observe(el);
        /* GG MOD END */
      }

      static init(root = document) {
        root.querySelectorAll('[data-clip-inline]:not([data-clip-initialized])').forEach(el => {
          NobileProductClipInline.initSingle(el);
        });
      }

      static initObserver() {
        new MutationObserver(mutations => {
          for (const mut of mutations) {
            mut.addedNodes.forEach(node => {
              if (node.nodeType !== 1) return;
              if (node.matches('[data-clip-inline]')) NobileProductClipInline.initSingle(node);
              node.querySelectorAll('[data-clip-inline]:not([data-clip-initialized])').forEach(el => {
                NobileProductClipInline.initSingle(el);
              });
            });
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      NobileProductClipInline.init();
      NobileProductClipInline.initObserver();
    });
    document.addEventListener('shopify:section:load', e => NobileProductClipInline.init(e.target));
  })();
  /* GG MOD END */

  })();

  /* GG MOD START - mobile-first product gallery placement */
  class NobileProductGalleryMobileFirst {
    constructor() {
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.resizeFrame = null;
      this.onResize = this.schedulePositionAll.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.positionAll());
      } else {
        this.positionAll();
      }

      window.addEventListener('resize', this.onResize);
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.onResize);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(this.onResize);
      }
      document.addEventListener('shopify:section:load', event => {
        requestAnimationFrame(() => this.positionAll(event.target));
      });
    }

    schedulePositionAll() {
      if (this.resizeFrame) return;

      this.resizeFrame = window.requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.positionAll();
      });
    }

    getProductSections(root = document) {
      const selector = '[data-section-type="product"][data-product-mobile-gallery-reposition="true"]';

      if (root.matches && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    insertAfter(marker, node) {
      if (!marker || !marker.parentNode || !node) return false;
      if (marker.nextElementSibling === node) return false;

      marker.parentNode.insertBefore(node, marker.nextSibling);
      return true;
    }

    refreshGallery(gallery) {
      if (!gallery) return;

      window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
        document.dispatchEvent(new CustomEvent('theme:resize'));
      });
    }

    positionSection(section) {
      const gallery = section.querySelector('[data-product-mobile-first-gallery]');
      const desktopHome = section.querySelector('[data-product-gallery-desktop-home]');
      const mobileHome = section.querySelector('[data-product-gallery-mobile-home]');

      if (!gallery || !desktopHome || !mobileHome) return;

      const marker = this.mobileQuery.matches ? mobileHome : desktopHome;
      const moved = this.insertAfter(marker, gallery);

      section.classList.toggle('product-gallery-is-mobile-flow', this.mobileQuery.matches);
      section.classList.toggle('product-gallery-is-desktop-flow', !this.mobileQuery.matches);

      if (moved) {
        this.refreshGallery(gallery);
      }
    }

    positionAll(root = document) {
      this.getProductSections(root).forEach(section => this.positionSection(section));
    }
  }
  new NobileProductGalleryMobileFirst();
  /* GG MOD END */

  /* GG MOD START - variant image swatches */
  class NobileVariantSwatches {
    constructor() {
      this.injectStyles();
      this.bindCollectionQuickAdd();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(() => this.applyVariantImages()));
      } else {
        requestAnimationFrame(() => this.applyVariantImages());
      }
      document.addEventListener('shopify:section:load', () => requestAnimationFrame(() => this.applyVariantImages()));
    }
    injectStyles() {
      if (document.getElementById('nobile-variant-swatches-styles')) return;
      const style = document.createElement('style');
      style.id = 'nobile-variant-swatches-styles';
      style.textContent = `
        .radio__inputs--variant-images {
          display: grid !important;
          grid-template-columns: repeat(var(--SWATCH-COLUMNS, 4), minmax(0, 1fr));
          gap: 8px;
        }
        radio-swatch[data-variant-preview-image] {
          width: 100%;
          min-width: 0;
        }
        radio-swatch[data-variant-preview-image] label {
          width: 100% !important;
          height: auto !important;
          background: var(--bg) !important;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
        }
        radio-swatch[data-variant-preview-image] .swatch__img-preview {
          display: block;
          width: 100%;
          aspect-ratio: var(--SWATCH-IMAGE-RATIO, 1 / 1);
          background-size: cover;
          background-position: center;
        }
        .radio__fieldset:has(.radio__inputs--variant-images) [data-option-value] {
          display: none;
        }
        radio-swatch[data-variant-preview-image] .value {
          font-size: calc(var(--font-3) * var(--FONT-ADJUST-BODY));
          font-weight: var(--FONT-WEIGHT-BODY);
          line-height: 1.4;
          opacity: 0.7;
          text-align: center;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          // white-space: nowrap;
        }
        radio-swatch[data-variant-preview-image] input:checked ~ label:after {
          display: none;
        }
        radio-swatch[data-variant-preview-image] input:checked ~ label .swatch__img-preview {
          outline: 2px solid currentColor;
          outline-offset: 2px;
        }
      `;
      document.head.appendChild(style);
    }
    applyVariantImages() {
      document.querySelectorAll('radio-swatch[data-variant-preview-image]').forEach(swatchEl => {
        const imageUrl = swatchEl.dataset.variantPreviewImage;
        const preview = swatchEl.querySelector('.swatch__img-preview');
        if (preview && imageUrl) {
          preview.style.backgroundImage = `url(${imageUrl})`;
        }
      });
      /* GG MOD START - collection swatch image src lazy load */
      document.querySelectorAll('[data-collection-swatch-image-src]').forEach(imageEl => {
        const imageUrl = imageEl.dataset.collectionSwatchImageSrc;
        if (imageUrl && !imageEl.getAttribute('src')) {
          imageEl.setAttribute('src', imageUrl);
        }
      });
      /* GG MOD END */
    }
    /* GG MOD START - collection quick add swatch interaction */
    bindCollectionQuickAdd() {
      document.addEventListener('click', (event) => {
        const swatchLink = event.target.closest('a[data-grid-item-variant]');
        if (!swatchLink) return;

        const card = swatchLink.closest('product-grid-item');
        if (!card) return;

        const selectedVariantId = swatchLink.getAttribute('data-grid-item-variant');
        if (selectedVariantId) {
          card.querySelectorAll('a[data-grid-link]').forEach((gridLink) => {
            const href = gridLink.getAttribute('href');
            if (!href) return;

            const url = new URL(href, window.location.origin);
            url.searchParams.set('variant', selectedVariantId);
            gridLink.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          });
        }

        const selectedSwatchValue = swatchLink.getAttribute('data-collection-swatch-value');
        const selectedSwatchLabel = card.querySelector('[data-collection-swatch-selected-value]');
        if (selectedSwatchValue && selectedSwatchLabel) {
          selectedSwatchLabel.textContent = selectedSwatchValue;
        }

        const quickAddForms = card.querySelectorAll('[data-collection-swatch-quick-add]');
        if (!quickAddForms.length) return;

        quickAddForms.forEach((form) => {
          if (form.getAttribute('data-collection-swatch-quick-add') === selectedVariantId) {
            form.removeAttribute('hidden');
          } else {
            form.setAttribute('hidden', '');
          }
        });
      });
    }
    /* GG MOD END */
  }
  new NobileVariantSwatches();
  /* GG MOD END */

  /* GG MOD START - collection image swatch progress state */
  class NobileCollectionSwatchProgress {
    constructor() {
      this.states = new WeakMap();
      this.initialize = this.initialize.bind(this);
      this.handleMutations = this.handleMutations.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.start());
      } else {
        this.start();
      }

      document.addEventListener('shopify:section:load', (event) => {
        requestAnimationFrame(() => this.initialize(event.target || document));
      });
      document.addEventListener('theme:resize', () => this.updateAll());
    }

    start() {
      this.initialize(document);

      if (!document.body || typeof MutationObserver === 'undefined') return;

      this.mutationObserver = new MutationObserver(this.handleMutations);
      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    handleMutations(mutations) {
      const containsProgressBar = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return node.matches('[data-collection-swatch-progress]') || node.querySelector('[data-collection-swatch-progress]');
      }));

      if (containsProgressBar) {
        requestAnimationFrame(() => this.initialize(document));
      }
    }

    initialize(root) {
      const bars = [];
      if (root.nodeType === Node.ELEMENT_NODE && root.matches('[data-collection-swatch-progress]')) {
        bars.push(root);
      }
      if (root.querySelectorAll) {
        bars.push(...root.querySelectorAll('[data-collection-swatch-progress]'));
      }

      bars.forEach((bar) => this.bindBar(bar));
    }

    bindBar(bar) {
      if (this.states.has(bar)) {
        this.scheduleUpdate(bar);
        return;
      }

      const swatchContainer = bar.closest('.grid__swatch__container--collection-images');
      const viewport = swatchContainer && swatchContainer.querySelector('.grid__swatch__hover');
      if (!viewport) return;

      const state = {
        bar,
        viewport,
        queued: false
      };
      this.states.set(bar, state);

      viewport.addEventListener('scroll', () => this.scheduleUpdate(bar), { passive: true });
      viewport.addEventListener('click', (event) => {
        const swatch = event.target.closest('a[data-swatch-index]');
        if (swatch) {
          const viewportRect = viewport.getBoundingClientRect();
          const swatchRect = swatch.getBoundingClientRect();
          const targetLeft = viewport.scrollLeft + swatchRect.left - viewportRect.left - (viewport.clientWidth - swatchRect.width) / 2;
          viewport.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
        }
        requestAnimationFrame(() => this.scheduleUpdate(bar));
      });
      bar.addEventListener('click', (event) => this.scrollToSwatch(event, bar));

      if (typeof ResizeObserver !== 'undefined') {
        state.resizeObserver = new ResizeObserver(() => this.scheduleUpdate(bar));
        state.resizeObserver.observe(viewport);
      }

      this.updateBar(bar);
      /* GG MOD START - align the filtered selected swatch thumbnail before the card is shown */
      requestAnimationFrame(() => this.alignSelectedSwatch(bar));
      /* GG MOD END */
    }

    /* GG MOD START - keep the initially selected color thumbnail visible in its horizontal gallery */
    alignSelectedSwatch(bar) {
      const state = this.states.get(bar);
      if (!state || !bar.isConnected) return;

      const selectedSwatch = state.viewport.querySelector('a[data-swatch-index][aria-selected="true"]');
      if (!selectedSwatch) return;

      const viewportRect = state.viewport.getBoundingClientRect();
      const swatchRect = selectedSwatch.getBoundingClientRect();
      const maxScrollLeft = Math.max(0, state.viewport.scrollWidth - state.viewport.clientWidth);
      const targetLeft = state.viewport.scrollLeft + swatchRect.left - viewportRect.left - (state.viewport.clientWidth - swatchRect.width) / 2;

      state.viewport.scrollTo({
        left: Math.min(maxScrollLeft, Math.max(0, targetLeft)),
        behavior: 'auto'
      });
    }
    /* GG MOD END */

    scrollToSwatch(event, bar) {
      const dot = event.target.closest('[data-collection-swatch-progress-index]');
      if (!dot) return;

      const state = this.states.get(bar);
      if (!state) return;

      const swatch = state.viewport.querySelector(`a[data-swatch-index="${dot.dataset.collectionSwatchProgressIndex}"]`);
      if (!swatch) return;

      event.preventDefault();

      const viewportRect = state.viewport.getBoundingClientRect();
      const swatchRect = swatch.getBoundingClientRect();
      const targetLeft = state.viewport.scrollLeft + swatchRect.left - viewportRect.left - (state.viewport.clientWidth - swatchRect.width) / 2;

      state.viewport.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });

      /* GG MOD START - auto select swatch thumbnail so main collection card image updates */
      // console.log('[NobileCollectionSwatchProgress] Dot clicked, selecting swatch:', swatch, 'for index:', dot.dataset.collectionSwatchProgressIndex);
      swatch.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
      swatch.click();
      /* GG MOD END */
    }

    scheduleUpdate(bar) {
      const state = this.states.get(bar);
      if (!state || state.queued || !bar.isConnected) return;

      state.queued = true;
      requestAnimationFrame(() => {
        state.queued = false;
        this.updateBar(bar);
      });
    }

    updateAll() {
      document.querySelectorAll('[data-collection-swatch-progress]').forEach((bar) => this.scheduleUpdate(bar));
    }

    updateBar(bar) {
      const state = this.states.get(bar);
      if (!state || !bar.isConnected) return;

      const swatches = state.viewport.querySelectorAll('a[data-swatch-index]');
      const swatchesByIndex = new Map(Array.from(swatches, (swatch) => [swatch.dataset.swatchIndex, swatch]));

      bar.querySelectorAll('[data-collection-swatch-progress-index]').forEach((dot) => {
        const swatch = swatchesByIndex.get(dot.dataset.collectionSwatchProgressIndex);
        if (!swatch) return;

        dot.classList.toggle('is-selected', swatch.getAttribute('aria-selected') === 'true');
      });
    }
  }
  new NobileCollectionSwatchProgress();
  /* GG MOD END */

  /* GG MOD START - product grid: se una card ha titolo o riga swatch colore su 2 righe,
     tutte le card della stessa riga riservano almeno 2 righe per quel blocco */
  class NobileGridRowAligner {
    constructor() {
      this.slots = [
        '.product__grid__title__wrapper',
        /* GG MOD - solo il blocco dot colore, non l'intero .grid__swatch__container:
           quest'ultimo contiene anche le frecce di navigazione dello slider (top:50%
           relativo all'intero contenitore), quindi allungarlo tutto sposta le frecce */
        '.collection-image-swatch-progress'
      ];
      this.scheduled = false;
      this.schedule = this.schedule.bind(this);
      this.align = this.align.bind(this);

      this.init();
    }

    init() {
      const start = () => {
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.schedule);
        } else {
          this.schedule();
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      document.addEventListener('theme:resize', this.schedule);
      document.addEventListener('shopify:section:load', this.schedule);

      if (typeof MutationObserver !== 'undefined' && document.body) {
        this.mutationObserver = new MutationObserver((mutations) => {
          const relevant = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            return node.matches('.js-grid') || node.closest('.js-grid') || !!node.querySelector('.js-grid');
          }));
          if (relevant) this.schedule();
        });
        this.mutationObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }

    schedule() {
      if (this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scheduled = false;
          this.align();
        });
      });
    }

    align() {
      document.querySelectorAll('.js-grid').forEach((grid) => this.alignGrid(grid));
    }

    alignGrid(grid) {
      const items = Array.from(grid.children).filter((item) => item.offsetParent !== null);
      if (items.length < 2) return;

      // Reset any previously applied correction before measuring natural heights again
      this.slots.forEach((selector) => {
        items.forEach((item) => {
          const el = item.querySelector(selector);
          if (el) el.style.minHeight = '';
        });
      });

      // Group cards into rows by their top offset (CSS Grid rows share the same offsetTop)
      const rows = new Map();
      items.forEach((item) => {
        const top = Math.round(item.offsetTop);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(item);
      });

      rows.forEach((rowItems) => {
        if (rowItems.length < 2) return;

        this.slots.forEach((selector) => {
          const els = rowItems.map((item) => item.querySelector(selector)).filter(Boolean);
          if (els.length < 2) return;

          const max = els.reduce((tallest, el) => Math.max(tallest, el.offsetHeight), 0);

          els.forEach((el) => {
            if (el.offsetHeight < max) {
              el.style.minHeight = `${max}px`;
            }
          });
        });
      });
    }
  }
  new NobileGridRowAligner();
  /* GG MOD END */

  /* GG MOD START - carosello video: mute toggle + autoplay (tutti/nessuno/centrale) + pausa video fuori viewport */
  class NobileVideoCarousel {
    constructor() {
      this.roots = document.querySelectorAll('[data-video-carousel]');
      if (!this.roots.length) return;

      this.roots.forEach((root) => this.bind(root));
    }

    bind(root) {
      const mode = root.dataset.carouselMode || 'all';
      const items = Array.from(root.querySelectorAll('[data-item]'));

      root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-mute-toggle]');
        if (toggle && root.contains(toggle)) {
          const toggleItem = toggle.closest('[data-item]');
          const canToggleMute = mode !== 'center' || toggleItem?.classList.contains('is-active');

          if (canToggleMute) {
            event.preventDefault();
            event.stopPropagation();

            const video = toggleItem?.querySelector('[data-video-autoplay]');
            if (video) {
              video.muted = !video.muted;
              toggle.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
              toggle.setAttribute('aria-label', video.muted ? toggle.dataset.labelUnmute : toggle.dataset.labelMute);
            }
            return;
          }
          // Non-active card in center mode: fall through so the click centers the card instead.
        }

        if (mode !== 'center') return;

        const item = event.target.closest('[data-item]');
        if (!item || !root.contains(item) || item.classList.contains('is-active')) return;

        const index = items.indexOf(item);
        if (index === -1) return;

        event.preventDefault();
        event.stopPropagation();
        root.carouselInstance?.select(index);
      });

      if (mode === 'center') {
        this.bindCenterMode(root, items);
        return;
      }

      if (mode === 'sequential') {
        this.bindSequentialMode(root, items);
        return;
      }

      if (mode === 'none') return;

      if (!('IntersectionObserver' in window)) return;

      const videos = root.querySelectorAll('[data-video-autoplay]');
      if (!videos.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playVideo(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      videos.forEach((video) => observer.observe(video));
    }

    playVideo(video) {
      if (!video) return;
      if (video.preload !== 'auto') {
        video.preload = 'auto';
        video.load();
      }
      video.play().catch(() => {});
    }

    bindCenterMode(root, items) {
      let activeVideo = null;
      let isRootVisible = !('IntersectionObserver' in window);

      const setActive = (index) => {
        items.forEach((item, i) => {
          const isActive = i === index;
          item.classList.toggle('is-active', isActive);

          const video = item.querySelector('[data-video-autoplay]');
          if (!video) return;

          if (isActive) {
            activeVideo = video;
            if (isRootVisible) this.playVideo(video);
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      };

      if ('IntersectionObserver' in window) {
        const rootObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isRootVisible = entry.isIntersecting;
              if (!activeVideo) return;
              if (isRootVisible) {
                this.playVideo(activeVideo);
              } else {
                activeVideo.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        rootObserver.observe(root);
      }

      const initialIndex = items.findIndex((item) => item.classList.contains('is-active'));
      setActive(initialIndex === -1 ? 0 : initialIndex);

      const attach = () => {
        if (!root.carouselInstance) {
          requestAnimationFrame(attach);
          return;
        }
        root.carouselInstance.on('change', (index) => setActive(Number(index)));
      };
      attach();
    }

    bindSequentialMode(root, items) {
      if (!items.length) return;

      // Move the fullscreen/floating player chrome to the end of <body>: rendered inline, a nested
      // `position: fixed` element can still get clipped or mis-stacked by an ancestor that creates its
      // own stacking context (overflow, transform, z-index...) — happens in both the standalone section
      // and, especially, the narrower product-info column. Do this once at bind time, before any click,
      // and keep a direct reference to it (querying by selector again after the move would still work,
      // but re-deriving it from `root`'s original DOM position would not).
      const fullscreenEl = root.parentElement?.querySelector('[data-video-fullscreen]');
      if (fullscreenEl && fullscreenEl.parentElement !== document.body) {
        document.body.appendChild(fullscreenEl);
      }

      let currentIndex = 0;
      let isRootVisible = !('IntersectionObserver' in window);
      let player = null;

      const getVideo = (item) => item?.querySelector('[data-video-autoplay]');

      const setActive = (index) => {
        currentIndex = index;
        items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      };

      const playCurrent = () => {
        if (player || !isRootVisible) return;
        this.playVideo(getVideo(items[currentIndex]));
      };

      const advance = () => {
        setActive((currentIndex + 1) % items.length);
        playCurrent();
      };

      items.forEach((item) => {
        const video = getVideo(item);
        if (!video) return;
        video.addEventListener('ended', () => {
          if (player) return;
          advance();
        });
      });

      if (items.length > 1 && 'IntersectionObserver' in window) {
        const rootObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isRootVisible = entry.isIntersecting;
              if (player) return;
              const video = getVideo(items[currentIndex]);
              if (!video) return;
              if (isRootVisible) {
                this.playVideo(video);
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.5 }
        );
        rootObserver.observe(root);
      }

      setActive(0);
      playCurrent();

      root.addEventListener('click', (event) => {
        const item = event.target.closest('[data-item]');
        if (!item || !root.contains(item)) return;
        event.preventDefault();

        const index = items.indexOf(item);
        if (index === -1) return;

        getVideo(items[currentIndex])?.pause();

        if (!player) {
          player = new NobileVideoFullscreenPlayer(fullscreenEl, items, {
            playVideo: (video) => this.playVideo(video),
            getIndex: () => currentIndex,
            setIndex: (i) => setActive(i),
            onEnded: () => advance(),
            onClose: () => {
              player = null;
              playCurrent();
            },
          });
        }
        player.open(index);
      });
    }
  }
  new NobileVideoCarousel();
  /* GG MOD END */

  /* GG MOD START - player fullscreen (mobile) / floating (desktop) del mode sequenziale: chiudi, condividi, prev/next, mute, progress bar */
  class NobileVideoFullscreenPlayer {
    constructor(el, items, { playVideo, getIndex, setIndex, onEnded, onClose }) {
      this.items = items;
      this.playVideoFn = playVideo;
      this.getIndex = getIndex;
      this.setIndex = setIndex;
      this.onEndedCallback = onEnded;
      this.onCloseCallback = onClose;

      // `el` is this instance's own [data-video-fullscreen] chrome, already moved to the end of
      // <body> by bindSequentialMode() before any click — keeping a direct reference here (rather
      // than re-deriving it from the carousel root's original DOM position) keeps multiple instances
      // on the same page independent regardless of where each one was moved to.
      this.el = el;
      if (!this.el) return;

      this.stage = this.el.querySelector('[data-fullscreen-stage]');
      this.progressBar = this.el.querySelector('[data-fullscreen-progress-bar]');
      this.closeBtn = this.el.querySelector('[data-fullscreen-close]');
      this.shareBtn = this.el.querySelector('[data-fullscreen-share]');
      this.prevBtn = this.el.querySelector('[data-fullscreen-prev]');
      this.nextBtn = this.el.querySelector('[data-fullscreen-next]');
      this.muteBtn = this.el.querySelector('[data-fullscreen-mute]');
      this.toast = this.el.querySelector('[data-fullscreen-toast]');

      this.wasScrollLocked = false;
      this.currentVideo = null;

      this.onTimeUpdate = () => {
        if (!this.currentVideo || !this.currentVideo.duration) return;
        const pct = (this.currentVideo.currentTime / this.currentVideo.duration) * 100;
        this.progressBar.style.width = `${pct}%`;
      };
      this.onVideoEnded = () => {
        this.progressBar.style.width = '0%';
        this.onEndedCallback();
        this.mount(this.getIndex());
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapTab(event);
      };

      this.bindChrome();
    }

    bindChrome() {
      this.closeBtn.addEventListener('click', () => this.close());
      this.shareBtn.addEventListener('click', () => this.share());
      this.prevBtn.addEventListener('click', () => this.step(-1));
      this.nextBtn.addEventListener('click', () => this.step(1));
      this.muteBtn.addEventListener('click', () => this.toggleMute());
    }

    open(index) {
      if (!this.el) return;

      const hasMultiple = this.items.length > 1;
      this.prevBtn.hidden = !hasMultiple;
      this.nextBtn.hidden = !hasMultiple;

      this.setIndex(index);
      this.mount(index);

      this.el.hidden = false;
      this.el.setAttribute('data-open', '');
      this.el.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', this.onKeydown);

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.wasScrollLocked = true;
        this.el.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
      }

      this.closeBtn.focus();
    }

    mount(index) {
      this.unmountMedia();

      const item = this.items[index];
      const media = item?.querySelector('.video-carousel__media');
      if (!media) return;

      // Clone (never move) the source node: the row's own video must stay visible in place — paused,
      // not removed — while the player shows its own independent copy. See unmountMedia().
      const clonedMedia = media.cloneNode(true);
      const video = clonedMedia.querySelector('[data-video-autoplay]');
      this.stage.appendChild(clonedMedia);
      if (!video) return;

      this.currentVideo = video;
      video.muted = true;
      this.updateMuteUi(true);
      video.currentTime = 0;
      this.progressBar.style.width = '0%';
      this.playVideoFn(video);

      video.addEventListener('timeupdate', this.onTimeUpdate);
      video.addEventListener('ended', this.onVideoEnded);
    }

    unmountMedia() {
      if (this.currentVideo) {
        this.currentVideo.removeEventListener('timeupdate', this.onTimeUpdate);
        this.currentVideo.removeEventListener('ended', this.onVideoEnded);
        this.currentVideo.pause();
      }
      this.stage.replaceChildren();
      this.currentVideo = null;
    }

    step(delta) {
      const length = this.items.length;
      if (!length) return;
      const nextIndex = (this.getIndex() + delta + length) % length;
      this.setIndex(nextIndex);
      this.mount(nextIndex);
    }

    close() {
      if (!this.el) return;

      this.unmountMedia();
      document.removeEventListener('keydown', this.onKeydown);

      if (this.wasScrollLocked) {
        this.el.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        this.wasScrollLocked = false;
      }

      this.el.hidden = true;
      this.el.removeAttribute('data-open');
      this.el.setAttribute('aria-hidden', 'true');

      this.onCloseCallback();
    }

    share() {
      const url = window.location.href;
      if (navigator.share) {
        navigator.share({ url, title: document.title }).catch(() => {});
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.toast.textContent = this.shareBtn.dataset.successMessage || 'Link copied to clipboard';
          this.toast.classList.add('is-visible');
          setTimeout(() => this.toast.classList.remove('is-visible'), 2000);
        });
      }
    }

    toggleMute() {
      if (!this.currentVideo) return;
      this.currentVideo.muted = !this.currentVideo.muted;
      this.updateMuteUi(this.currentVideo.muted);
    }

    updateMuteUi(muted) {
      this.muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      this.muteBtn.setAttribute('aria-label', muted ? this.muteBtn.dataset.labelUnmute : this.muteBtn.dataset.labelMute);
    }

    trapTab(event) {
      const focusable = [this.closeBtn, this.shareBtn, this.prevBtn, this.nextBtn, this.muteBtn].filter(
        (btn) => btn && !btn.hidden
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
  /* GG MOD END */

    // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.
  })();
